import React,{Component}   from 'react';
import dingdingliuchengtu from "./assets/img/dingdingliuchengtu.png";

import laowumianshi1 from './assets/img/laowumianshi1.png';
import laowumianshi2 from './assets/img/laowumianshi2.png';
import ruzhigaozhi from './assets/img/ruzhigaozhi.png';
import ruzhishengming1 from './assets/img/ruzhishengming1.png';
// import ruzhidengji3 from './assets/img/ruzhidengji3.png';
import zhiyinshouce1 from './assets/img/zhiyinshouce1.png';
import zhiyinshouce2 from './assets/img/zhiyinshouce2.png';
import lizhishenpibiao1 from './assets/img/lizhishenpibiao1.png';
import ddlizhiliuchengtu from './assets/img/ddlizhiliuchengtu.png';

import lizhimaintanbiao1 from './assets/img/lizhimaintanbiao1.png';
import lizhizhengming1 from './assets/img/lizhizhengming1.png';
import jiechulaodonghetong1 from './assets/img/jiechulaodonghetong1.png';
import xudinglaodonghetong1 from './assets/img/xudinglaodonghetong1.png';
import xudinglaodonghetong2 from './assets/img/xudinglaodonghetong2.png';
import lizhijiaojiebiao1 from './assets/img/lizhijiaojiebiao1.png';
import fuliyulanbiao from './assets/img/fuliyulanbiao.png';


import gongzhongdagang1 from './assets/img/gongzhongdagang1.png';
import zhengchexiaoshou1 from './assets/img/zhengchexiaoshou1.png';
import peijianxiaoshou1 from './assets/img/peijianxiaoshou1.png';
import fuwuxiaoshou1 from './assets/img/fuwuxiaoshou1.png';
import kehuxinxi1 from './assets/img/kehuxinxi1.png';

import guanlirenyuan1 from './assets/img/guanlirenyuan1.png';
import weixiujigong1 from './assets/img/weixiujigong1.png';
import xuetugong1 from './assets/img/xuetugong1.png';
import kufangguanli1 from './assets/img/kufangguanli1.png';
import wuliupeisong1 from './assets/img/wuliupeisong1.png';
import caigoujihua1 from './assets/img/caigoujihua1.png';
import suopeibaodan1 from './assets/img/suopeibaodan1.png';
import renshizhuanyuan1 from './assets/img/renshizhuanyuan1.png';
import caiwujizhang1 from './assets/img/caiwujizhang1.png';
import tongjirenyuan1 from './assets/img/tongjirenyuan1.png';
import IT1 from './assets/img/IT1.png';
import guojimaoyi1 from './assets/img/guojimaoyi1.png';
import fawuzhuanyuan1 from './assets/img/fawuzhuanyuan1.png';

import renshibankuai from './assets/img/renshibankuai.png';
import renshibankuai1 from './assets/img/renshibankuai1.png';
import renshibankuai2 from './assets/img/renshibankuai2.png';
import renshibankuai3 from './assets/img/renshibankuai3.png';
import xingzhengbankuai from './assets/img/xingzhengbankuai.png';
import houqinbaozhangbankuai from './assets/img/houqinbaozhangbankuai.png';
import jifenzhishenpi from './assets/img/jifenzhishenpi.png';
import caiwubankuai from './assets/img/caiwubankuai.png';
import chejianchanyegongren from './assets/img/chejianchanyegongren.png';
import jishugongyikaifarenyuan from './assets/img/jishugongyikaifarenyuan.png';
import zhijianshebeirenyuan from './assets/img/zhijianshebeirenyuan.png';


class Section$ extends Component {

    showDrawer = (data) => {
        this.props.enclosureShow(data.target.id,data.target.title)
    }

    render(){
        return(
            <div style={{textIndent: '2em'}}>
                <div style={{textAlign: 'center'}}>
                    <h1 name="0-2" className="point" id="0-2">第三章 人事行政管理制度</h1></div>
                <br/>
                <div style={{textIndent: '2em'}}>
                    <h2 name="0-2-0" className="point" id="0-2-0">一、人事招/入/离/转/调/管理细则</h2>
                    <h3 name="0-2-0-0" className="point" id="0-2-0-0">1、招聘录用管理细则</h3>
                    <h3 name="0-2-0-0-0" className="point" id="0-2-0-0-0">1.1总则</h3>
                    <h4>第一条 适用对象</h4>
                    <p> 公司所有招聘员工。</p>
                    <h4>第二条 权责单位</h4>
                    <p>人力资源部门负责本制度的制定、修改、解释等工作；董事长负责本制度制定、修改等的核准。 人力资源部门负责招聘录用工作的组织、管理工作。</p>
                    <br/>
                    <h3 name="0-2-0-0-1" className="point" id="0-2-0-0-1">1.2招聘录用原则</h3>
                    <h4>第三条 招聘录用的原则</h4>
                    <p>公司招聘坚持公开、公平、公正、因岗择人、择优录用的原则。</p>
                    <h4>第四条 招聘组</h4>
                    <p>公司成立招聘组负责对人员的筛选，其小组成员由人力资源部、用人部门、管理公司总经理或公司指派的人员组成。</p>
                    <p>针对不同对象的招聘人员，其面试考官构成如下：</p>
                    <p>1、对于普通员工，初试考官为人力资源部招聘专员，复试考官由人力资源部经理和用人部门经理/总监及管理公司总经理组成，最后由用人部门经理/总监核定；</p>
                    <p>2、对于基层管理人员，初试考官由人力资源部招聘专员和用人部门经理/总监组成，复试考官由人力资源部经理和用人部门经理/总监及管理公司总经理组成，最后由用人部门的管理公司总经理核定；</p>
                    <p>3、对于中高层管理人员及公司所需的特殊人才，面试考官一般由人力资源部经理、董事长或专家委员会组成，董事长拥有对其录用决策的最终决定权。</p>
                    <br/>
                    <h3 name="0-2-0-0-2" className="point" id="0-2-0-0-2">1.3招聘需求</h3>
                    <p>招聘工作从招聘需求的提出开始，招聘需求由各用人部门经理/总监提出，其主要内容包括部门现总人数、各岗位人数分配比例、所需招聘岗位名称及要求、岗位职责、所需求原因等内容。</p>
                    <h4>第五条 需求申请</h4>
                    <p>各用人部门根据业务发展、工作需要和人员使用情况，向管理公司总经理提出员工招聘的要求，填写招聘人员需求申请表，报人力资源部审批。如未提报用人需求或提报审批未通过，不给予招聘。</p>
                    <h4>第六条 突发的人员需求</h4>
                    <p>因新增加的业务或其他原因导致突发的人员需求，而公司现有内部人员缺乏此种人才或不足时，用人部门经理/总监应及时将人员需求申请上报人力资源部审批。</p>
                    <h4>第七条 储备人才需求</h4>
                    <p>若为了促进公司目标的实现，而需储备一定数额的各类专门人才（如大学毕业生等专业技术人才），由用人部门经理/总监按流程将储备人员需求上报人力资源部审批。</p>
                    <br/>
                    <h3 name="0-2-0-0-3" className="point" id="0-2-0-0-3">1.4招聘渠道</h3>
                    <p>公司招聘分为内部推荐和社会招聘。</p>
                    <h4>第八条 内部推荐</h4>
                    <p>内部推荐是指公司内部员工在获知内部招聘信息后，按规定程序前来应聘，公司对应聘员工进行选拔并对合适的员工予以录用的过程。</p>
                    <p>所有公司正式员工都可以提出应聘申请，且公司鼓励员工积极推荐优秀人才或提供优秀人才的信息，对内部推荐的人才可以在同等条件下优先录取，但不得降低录用的标准。</p>
                    <p>内部推荐人先将人员基本信息情况提前以面谈或电话沟通方式报至人力资源部，确认其基本信息符合入职要求后人力资源部通知任用部门负责人面试事宜等流程，面试成功且入职者，入职三个月后成为正式员工，以动态积分考核标准中的信息贡献分奖励推荐人100分/人；被推荐者若为实习生，面试成功且入职者，入职六个月后，以动态积分考核标准中的信息贡献分奖励推荐人50分/人；如人力资源部认为其不符合入职要求，则回复内部介绍人并说明理由；如不到三个月期限，则信息贡献分视为无效。</p>
                    <p><strong>注:</strong>人力资源部、所需部门经理/总监、直属上级主管给本部门或本科室团队推荐人才或推荐同岗位人才属于分内工作，无积分奖励。</p>
                    <h4>第九条 社会招聘</h4>
                    <p>社会招聘是指在出现职位空缺而内部推荐招聘无法满足需要时，公司从社会中选拔人员的过程。外部招聘的方式主要有通过招聘媒体网站等多种渠道发布招聘信息、参加人才招聘会、校园招聘会、通过职业介绍所等。</p>
                    <p>人力资源部通过各种招聘途径发布招聘用人需求，并筛选简历通知面试，初试中应聘人跟据应聘人员身份填写相应<strong style={{color:'#6699FF',cursor:'pointer'}} type="primary" id='Enclosure31' title="《应聘面试登记表》" onClick={(value)=>this.showDrawer(value)}>《面试登记表》</strong>、并提供相关资历证书以备存档，初试合格后人力资源部组织协调任用部门共同进行复试，如复试合格由人力资源部通知应聘人员入职事宜（根据面试地点、面试人员安排等情况可一次性全部完成面试流程）；</p>
                    <p><strong>注：</strong>人任用部门经理/总监接到人力资源部的面试通知后方可安排面试事宜，如应聘人员在外地需要提前与人力资源部沟通，由人力资源部协调以电话面试或网络视频形式进行初试，未安排面试之前任用部门不允许安排住宿；如任用部门在未接到人力资源部通知办理入职的情况下自行安排上岗，工资发放则以人力资源部办理入职的日期计算上岗时间，提前上岗工资由部门负责人自行承担并向应聘人员解释。
                    </p>
                    <h3 name="0-2-0-0-4" className="point" id="0-2-0-0-4">1.5人员甄选</h3>
                    <h4>第十条 简历的筛选</h4>
                    <p>招聘信息发布后，由人力资源部招聘专员对收集到的应聘人员相关资料进行初步审核，对初步筛选出的合格应聘者，以电话的方式告知他们前来公司参加下一环节的甄选。</p>
                    <h4>第十一条 面试</h4>
                    <p>面试一般分为初试与复试两个环节。根据招聘职位的不同，也可以有第三轮甚至更多环节的面试。</p>
                    <p><strong>1、</strong>初试。主要是对应聘者基本素质、基本专业技能、价值取向、岗位与薪资匹配度等做出的一个基本判断。</p>
                    <p><strong>2、</strong>复试。根据初试的结果，人力资源部对符合空缺职位要求的应聘者安排复试，主要是对应聘者与岗位的契合度进行考察，应聘者对岗位所需技能的掌握程度、胜任该岗位所需具备的综合能力等方面；最终人力资源部与用人部门经理、复试者三方确定试用期岗位、职级、薪资、试用期限、转正后薪资范围等内容核定后，方可录用。
                    </p>
                    <h3 name="0-2-0-0-5" className="point" id="0-2-0-0-5">1.6背景调查</h3>
                    <h4>第十二条 背景调查</h4>
                    <p>就应聘者与工作有关的一些背景信息进行查证，以进一步确定应聘者的任职资格。</p>
                    <p>经公司甄选合格的人员，在公司决定录用之前，视情况可对其作相关的背景进行调查，调查的主要内容包括学历水平、工作经历、综合素质等；审核其离职证明及离职原因。</p>
                    <h3 name="0-2-0-0-6" className="point" id="0-2-0-0-6">1.7人员录用</h3>
                    <h4>第十三条 录用通知</h4>
                    <p>经过笔试、面试环节的选拔，经公司考核合格的人员，在做出录用决策后的三个工作日内，由人力资源部门以邮件形式下发录用通知书通知对方。</p>
                    <h4>第十四条 录用审批</h4>
                    <p>招聘专员在钉钉系统上提交录用审批（审批包括：员工姓名、用人部门、入职岗位、直属上级、试用期薪资、试用期职级、转正后预计薪资范围、试用期限、员工类型、手机号、面试简历信息、签署合同户别），并经过人事科确认签署劳动合同户别，用人部门经理/总监、管理公司总经理、人力资源部经理、各地区行政负责人、副董事长逐级审批，填写录用意见。审批通过后方可对接办理入职。此审批请于发起日三天内完成本次审批流程。如超出时间直接对审批人进行考核。</p>
                    <h4>第十五条 员工的报到</h4>
                    <p>被录用员工在接到公司的录用通知后，必须在规定的时间内到公司报到。若在发出录用通知后的10天内不能正常按时报到者，公司有权取消其录用资格，特殊情况经批准后可延期报到。</p>
                    <h4>第十六条 员工的正式录用</h4>
                    <p>被录用人员按规定时间来公司报到后，需携带资料及办理的手续：</p>
                    <p><strong>1、</strong>填写<div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure33' title="《员工登记表》" onClick={(value)=>this.showDrawer(value)}>《员工登记表》</a></div></p>
                    <p><strong>2、</strong>签属入职声明书；</p>
                    <p><strong>3、</strong>验证其应届生身份或离职状态的相关证明（针对岗位提供）；</p>
                    <p><strong>4、</strong>将个人相关资料包括身份证原件、学历原件、相关职称证或资质证原件；</p>
                    <p><strong>5、</strong>体检报告或健康证（体检报告或健康证提交时间需在半年之内有效）</p>
                    <p><strong>6、</strong>纸制版一寸彩色照两张、第一次在京参保员工需提供社保照片：一寸白底照片电子版（格式：白底jpg格式，宽度358像素，高度441像素，不小于9KB，不大于20KB）；</p>
                    <p><strong>7、</strong>工资卡（所属公司开户地区的银行卡）</p>
                    <p>应聘人员应确保上述所列之规定的相关资料在办理入职当日提供，并保证与其他用人单位已终止劳动关系，否则公司有权以其不符合录用条件为由不能录用。</p>
                    <h4>第十七条 录用时声明</h4>
                    <p>公司拟录用的所有人员，应在公司制作的诚信声明表上声明以下事项：</p>
                    <p>1、在入职申请表上所填写的内容均真实无误；</p>
                    <p>2、无影响工作的慢性疾病、传染病或其他重大疾病或不适合招聘岗位的其他疾病；</p>
                    <p>3、无刑事犯罪记录；</p>
                    <p>4、已依法与原用人单位办理完解除或终止劳动合同的手续，并向公司出具相关证明；</p>
                    <p>5、若姓名、住址、电话号码、紧急联络人等相关个人资料发生变更，保证变更之日起3日内书面通知公司。否则公司可按原个人资料进行通知或公告，即履行法定告知义务。</p>
                    <h3 name="0-2-0-0-7" className="point" id="0-2-0-0-7">1.8 附则</h3>
                    <h4>第十八条 解释权</h4>
                    <p>本制度的解释权归人力资源部。</p>
                    <h4>第十九条 效力</h4>
                    <p>公司以前颁布的相关制度与本制度相抵触的，以本制度为准。本制度自颁布之日起实施。</p>
                    <div><img src={dingdingliuchengtu} alt="" style={{width: '600px',display: 'block',margin: '0 auto'}}/></div>
                    <br/><h3>附件名称</h3>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure31' title="《应聘面试登记表》" onClick={(value)=>this.showDrawer(value)}>《应聘面试登记表》</a></div>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure32' title="《实习生面试登记表》" onClick={(value)=>this.showDrawer(value)}>《实习生面试登记表》</a></div>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure34' title="《劳务人员面试登记表》" onClick={(value)=>this.showDrawer(value)}>《劳务人员面试登记表》</a></div>
                    <br/>
                    <h2 name="0-2-0-1" className="point" id="0-2-0-1">2、员工入职管理细则</h2>
                    <h4>目的</h4>
                    <p>公司员工入职工作流程，帮助新员工消除对新环境的陌生感，顺利将其导入公司的文化氛围中，在试用期内对新员工的工作进行跟踪和评估，为员工转正提供依据，同时有效规范用工风险。</p>
                    <h4>适用范围</h4>
                    <p>适用于云豪集团本部及各分（子）公司新员工入职管理。</p>
                    <h3 name="0-2-0-1-0" className="point" id="0-2-0-1-0">2.1入职通知</h3>
                    <p>经过人力资源部面试环节的选拔，经各管理公司各部门逐级审核考核合格的人员信息资料，在做出录用决策后的三个工作日内审批通过，由人力资源部招聘科通知对方。</p>
                    <h3 name="0-2-0-1-1" className="point" id="0-2-1-1">2.2员工的报到</h3>
                    <p>被录用员工在接到公司的录用通知后，必须在每周二、周四规定的时间内到公司报到，并集中办理入职手续。若在发出录用通知后的10天内不能正常按时报到者，公司有权取消其录用资格，特殊情况经批准后可延期报到。</p>
                    <h3 name="0-2-0-1-2" className="point" id="0-2-0-2-2">2.3员工的正式入职</h3>
                    <p>被录用人员按规定时间来公司报到，当天应向公司提供以下资料和证明，人力资源部复印扫描存档后办理入职手续并依次建立员工档案。需办理如下手续：</p>
                    <p><strong>1、</strong>填写并签署《新员工入职告知书》、《入职声明书》、《员工入职登记表》；</p>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure35' title="《新员工入职告知书》" onClick={(value)=>this.showDrawer(value)}>《新员工入职告知书》</a></div>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure36' title="《入职声明书》" onClick={(value)=>this.showDrawer(value)}>《入职声明书》</a></div>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure33' title="《员工入职登记表》" onClick={(value)=>this.showDrawer(value)}>《员工入职登记表》</a></div>
                   <p></p>
                    <p><strong>2、</strong>提交近期个人免冠照片2张（纸质版和电子版）电子版照片格式：白底jpg格式，宽度358像素，高度441像素，大小于9KB，不大于20KB；</p>
                    <p><strong>3、</strong>审核其应届生身份或离职状态的相关证明；</p>
                    <p><strong>4、</strong>将相关资料交与人力资源部人事科，包括学历、学位、职称、驾照、护照、荣誉证书等原件及复印件（验正后扫描存档，原件退还本人）；</p>
                    <p><strong>5、</strong>接收体检报告或正规体检单位办理的健康证（体检报告有效时间：半年之内，健康证需在有效期之内）；</p>
                    <p><strong>6、</strong>手机下载集团公司办公软件“钉钉”系统，方便后续手续办理及工作</p>
                    <p><strong>7、</strong>与新入职员工签订劳动、劳务或实习类合同及相关保密协议；</p>
                    <p><strong>8、</strong>培训专员统一进行《新员工入职指引手册》培训。</p>
                        <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure37' title="《新员工入职指引手册》" onClick={(value)=>this.showDrawer(value)}>《新员工入职指引手册》</a></div>
                    <p></p>
                    <p>应聘人员应确保上款所列之规定的相关资料在公司要求的期限之前提供，并保证与其他用人单位已终止劳动关系，否则公司有权以其不符合录用条件为由解除其劳动合同。</p>
                    <p>应聘人员必须保证向公司提供的资料、声明、陈述内容真实无误，若发现伪报或伪造，属于严重违反公司规章制度，公司有权解除其劳动合同。</p>
                    <p>劳动合同是公司与员工在自愿基础上签订的，其内容已经政府有关部门审定通过，具有法律效力，员工必须仔细阅读，并严格遵守合同内的各项规定。为保障公司与客户的保密信息，公司同时要求员工与公司签订保密协议，员工必须仔细阅读，并严格遵守。</p>
                    <h3 name="0-2-0-1-3" className="point" id="0-2-0-1-3">2.4员工的社会保险缴纳</h3>
                    <h4>1、参保原则</h4>
                    <p>与公司签订劳动合同，并确定为参保对象的员工，公司将在合同有效期内按规定缴纳五险（具体缴纳种类根据公司相关制度执行），入职日期为每自然月15日（包括15日）之前的将于当月增员缴纳保险，于15日之后入职的将于次月增员缴纳下月保险。</p>
                    <h4>2、参保项目</h4>
                    <p>养老保险、医疗保险、工伤保险、生育保险、失业保险</p>
                    <h4>3、参保须知</h4>
                    <p><strong>3.1</strong>公司将在员工签订劳动合同后为其办理社会保险参保手续。</p>
                    <p><strong>3.2</strong>参保所需资料：</p>
                    <h4>一、第一次在京参保员工需提供以下材料信息：</h4>
                    <p>1、一寸白底照片电子版（格式：白底jpg格式，宽度358像素，高度441像素，大小于9KB，不大于20KB）</p>
                    <p>2、银行卡信息：开户行及帐号（北京工商银行卡/北京浦发银行/天津工商银行卡3个银行中指定1家，入职邀请函中将注明所需办理的银行卡信息）</p>
                    <p>3、户口性质：本市、外地/城镇、农户</p>
                    <p>4、户口所在地编码 </p>
                    <h4>二、非第一次在北京参保的员工需提供下列材料信息：</h4>
                    <p>1、银行卡信息：开户行及帐号（北京工商银行卡/北京浦发银行/天津工商银行卡3个银行中指定1家，入职邀请函中将注明所需办理的银行卡信息）</p>
                    <p>2、户口性质：本市、外地/城镇、农户</p>
                    <p>3、户口所在地编码</p>
                    <h3 name="0-2-0-1-4" className="point" id="0-2-0-1-4">2.5入职时声明</h3>
                    <p>公司拟录用的所有人员，应在公司制作的诚信声明表上声明以下事项：</p>
                    <p><strong>1、</strong>在入职申请表上所填写的内容均真实无误；</p>
                    <p><strong>2、</strong>无影响工作的慢性疾病、传染病或其他重大疾病或不适合招聘岗位的其他疾病；</p>
                    <p><strong>3、</strong>无刑事犯罪记录；</p>
                    <p><strong>4、</strong>已依法与原用人单位办理完解除或终止劳动合同的手续，并向公司出具相关证明；</p>
                    <p><strong>5、</strong>若姓名、住址、电话号码、紧急联络人等相关个人资料发生变更，保证变更之日起3日内书面通知公司。否则公司可按原个人资料进行通知或公告，即履行法定告知义务。</p>
                    <h3 name="0-2-0-1-5" className="point" id="0-2-0-1-5">2.6入职指引培训</h3>
                    <p>为了让员工尽快融入公司，帮助新员工适应新的环境，了解所在的团队，快速熟悉新的工作和云豪集团，在人力资源部和所属部门的指引下，于入职当天完成入职手续办理后，统一进行《新员工入职指引手册》培训。</p>
                    <p>培训内容包括：人力资源部人事手续办理、资产部与后勤部物资领取、公司简介及组织结构讲解、试用期的规章制度及福利、试用期工作与学习指引、部门的岗位培训及试用期工作计划等。</p>
                    <p>要求每位新入职员工在人力资源部的引导下与部门入职引导人完成《新员工入职指引手册》的填写，仔细阅读并熟知其内容，妥善保存，按其内容指引完成入职及后续手续。如有问题，请与对应人员联系。同时要求部门入职引导人或部门导师认真负责的完成对新入职员工培训，此项考核动态积分200-500分。</p>
                    {/* <p>附件《新员工入职告知书》</p>
                    <br/> */}
                        {/* <div style={{textAlign:'center'}}>
                            <img src={ruzhigaozhi} alt="" style={{width: '900px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件《入职声明书》</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={ruzhishengming1} alt="" style={{width: '500px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件《员工入职登记表》</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={ruzhidengji3} alt="" style={{width: '900px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件《新员工入职指引手册》</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={zhiyinshouce1} alt="" style={{width: '900px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={zhiyinshouce2} alt="" style={{width: '900px',display:'block',margin:'0 auto'}}/>
                        </div> */}
                    <br/>
                    <h3 name="0-2-0-2" className="point" id="0-2-0-2">3、员工离职管理细则</h3>
                    <h3 name="0-2-0-2-0" className="point" id="0-2-0-2-0">3.1 目的</h3>
                    <p>为维护公司合法行使用工权，保障公司员工的合法权益，规范公司员工的离职管理，特制订本制度。</p>
                    <h3 name="0-2-0-2-1" className="point" id="0-2-0-2-1">3.2 适用范围</h3>
                    <p>适用于公司全体员工。</p>
                    <h3 name="0-2-0-2-2" className="point" id="0-2-0-2-2">3.3 离职种类</h3>
                    <p>一、试用期内离职：指员工在试用期内，公司或员工个人因正当理由提出终止劳动合同关系。</p>
                    <p>二、合同期满离职：指劳动合同期满，公司或员工任何一方不愿续签劳动合同，双方劳动合同关系自然终止。</p>
                    <p>三、合同期内离职：指劳动合同期内，提前终止劳动合同关系的离职，包括辞职、辞退、擅自离职。</p>
                    <p>1、辞职：指员工方由于自身原因等合法因素，向公司提出提前终止劳动合同关系。</p>
                    <p>2、辞退：因下列原因，由公司提出与员工提前终止劳动合同关系。其中：</p>
                    <p>A、员工有下列情形之一的，公司可以即时解除劳动合同，予以辞退（因员工过失而提前解除劳动合同）。</p>
                    <p>① 在试用期间被证明不符合录用条件的；</p>
                    <p>② 严重违反用人单位的规章制度的；</p>
                    <p>③ 严重失职，营私舞弊，给用人单位造成重大损害的；</p>
                    <p>④ 劳动者同时与其他用人单位建立劳动关系，对完成本单位的工作任务造成严重影响，或者经用人单位提出，拒不改正的；</p>
                    <p>⑤ 以欺诈、胁迫的手段使公司在违背真实意思的情况下订立或者变更劳动合同的；</p>
                    <p>⑥ 被依法追究刑事责任的。</p>
                    <p>B、有下列情形之一的，公司提前三十日以书面形式通知员工本人可以解除劳动合同，予以辞退（非员工过失而提前解除劳动合同）：</p>
                    <p>① 劳动者患病或者非因工负伤，在规定的医疗期满后不能从事原工作，也不能从事由用人单位另行安排的工作的；</p>
                    <p>② 劳动者不能胜任工作，经过培训或者调整工作岗位,仍不能胜任工作的；</p>
                    <p>③ 劳动合同订立时所依据的客观情况发生重大变化，致使劳动合同无法继续履行，经用人单位与劳动者协商，未能就变更劳动合同内容达成协议的；</p>
                    <p>C、员工有下列情形之一的，公司可以作出终止劳动合同关系，予以开除的决定：</p>
                    <p><strong>① 连续旷工3日，每季度累计旷工7日，扣罚月工资的30%，予以开除。</strong></p>
                    <p><strong>② 连续迟到5次或连续早退5次，每季度累计早退10次或累计迟到10次。</strong></p>
                    <p>③ 一年内记过三次以上（含三次）者；</p>
                    <p>④ 挪用公款、收受贿赂、酬金、虚报工单、冒领各项费用者。</p>
                    <p>⑤ 工作疏忽、贻误要务，致使公司蒙受重大损失（10000元及以上），违抗命令、擅离职守、情节严重者。</p>
                    <p>⑥ 仿效上级签字、盗用印鉴或涂改公司文件、泄露业务秘密，情节严重者。</p>
                    <p><strong>⑦ 聚众罢工、造谣生事、打架斗殴、偷窃、赌博及其他严重损毁公司形象者。</strong></p>
                    <p><strong>⑧ 因员工个人问题而影响到个人或其他人员工作的，或对公司形象产生不良影响的。</strong></p>
                    <p>4、擅自离职 ：指员工未申请辞职或辞职申请未经批准或未按公司要求办理离职手续，擅自离开公司工作岗位。</p>
                    <h3 name="0-2-0-2-3" className="point" id="0-2-0-2-3">3.4 离职管理职责</h3>
                    <p>一、离职员工所在部门</p>
                    <p>（一）接收员工书面辞职申请及钉钉系统辞职申请并提出意见。</p>
                    <p>（二）提出与所辖员工除辞职外的其它种类的终止劳动合同关系的建议。</p>
                    <p>（三）与离职员工进行离职面谈。</p>
                    <p>（四）办理获批离职员工在本部门工作事项、工具、资料等离职交接。</p>
                    <p>二、人力资源部</p>
                    <p>（一）员工至人力资源部门领取 附件《员工离职申请表》、<strong>《员工离职交接表》</strong></p>
                    <p>（二）与离职人员进行离职面谈，填写 附件《员工离职面谈表》</p>
                    <p>（三）办理并审核公司批准离职员工各项物资项的离职交接。</p>
                    <p>（四）办理公司离职员工的薪酬结算、社保终止等事宜。</p>
                    <p>三、财务部</p>
                    <p>审核离职员工借支状况及薪酬结算。</p>
                    <p>四、以上部门如未按要求办理离职手续，导致交接不清，给公司造成损失，应追究相关人员责任。</p>
                    <h3 name="0-2-0-2-4" className="point" id="0-2-0-2-4">3.5 离职管理的审批权限</h3>
                    <p>一、试用期内员工离职，逐级审批权限：本部门组长/队长、科长、部门总监或经理、管理公司总经理、人力资源部、各基地行政负责人。</p>
                    <p>二、转正后正式员工离职，逐级审批权限：本部门组长/队长、科长、部门总监或经理、管理公司总经理、人力资源部、各基地行政负责人、董事长。</p>
                    <p>注：各级别越高员工离职，审批权限人则从其上一级开始逐级审批。</p>
                    <p>三、钉钉系统离职审批流程自发起之日，各负责人逐级审批于5日之内全部处理完成，避免存在人事纠纷等劳动风险。</p>
                    <h3 name="0-2-0-2-5" className="point" id="0-2-0-2-5">3.6解除劳动合同流程</h3>
                    <p>一、员工提出离职流程</p>
                    <p>二、公司提出离职流程</p>
                    <h3 name="0-2-0-2-6" className="point" id="0-2-0-2-6">3.7流程各环节作业规范</h3>
                    <p>一、离职申请规范及要求</p>
                    <p>（一）辞职：</p>
                    <p>1、合同期内员工辞职申请条件及时间规定。</p>
                    <p>1.1 职级为2—4级需提前一个月申请；</p>
                    <p>1.2 职级为5—7级需提前三个月申请；</p>
                    <p>1.3 职级为8级及以上需提前六个月申请；</p>
                    <p>2、试用期内员工辞职需提前七天提出申请。</p>
                    <p>3、需按照上述规定时间提前于集团办公系统“钉钉”发起‘离职申请’审批；</p>
                    <p>注：各岗位需严格按照上述要求执行，若因个人原因未按此要求操作，相应一切后果由个人承担。</p>
                    <p>4、离职面谈</p>
                    <p>①员工提出离职申请后，由所在部门及人力资源部与员工进行离职面谈。了解员工离职原因并确定能否挽留。</p>
                    <p>②部门提出的离职申请，在申请获批后，由所在部门及人力资源部与员工进行离职面谈，向员工说明辞退等提前解除劳动合同的原因或其违纪事实。</p>
                    <p>③离职面谈参与人均应听取员工陈述的离职原因及其对公司的意见和建议，离职原因必须真实详细，面谈负责人与离职人员一并在《离职面谈表》签字由人力资源部留存归档；</p>
                    <p>5、员工提出辞职由人力资源部及所在部门负责人或管理公司总经理与离职申请人沟通后，离职申请人仍决定离职的，需填写《离职申请表》经任用部各级负责人逐级审批，并经人力资源部、各基地行政管理责任人、董事长批准后办理有关离职手续。</p>
                    <p>6、离职员工按照《员工离职申请表》、《员工离职交接表》（工作交接、物资回收、结算工资所用）所示流程办理离职手续。</p>
                    <p>7、离职手续办理完毕后，到人力资源部领取《解除（终止）劳动合同协议》《离职证明》等手续办理，未支付薪资在规定薪资发放日发放。</p>
                    <p><strong>注：</strong>离职员工需严格按照上述规定办理离职手续，并保证《员工离职申请表》、《员工离职交接表》、《离职面谈表》所填写内容真实无误，一经公司发现存在欺瞒、欺诈等内容，一切后果由个人承担，且公司保留追究其法律责任的权利。
                    </p>
                    <p>（二）辞退：</p>
                    <p>1、员工擅自离岗、旷工或违纪事实达到公司规章制度所订立的辞退条件或擅自离岗事实成立，由违纪员工所在部门出具书面材料及辞退依据，提出处理意见，提交公司人力资源部。</p>
                    <p>2、辞退决定做出后，由人力资源部填写《解除（终止）劳动合同通知书》，向被辞退离职员工告知辞退决定和办理离职的时间及相关要求。</p>
                    <p>3、书面通知的主要方式及要求： </p>
                    <p>①被辞退离职人当面签收。签收后由人力资源部将签收件原件存档。</p>
                    <p>②员工拒绝签收的，应邮寄送达，依照员工档案所留地址以快递方式寄达（快递适用中国邮政），由人力资源部将发信存根存档。</p>
                    <p>③邮寄函件被退回的，应通过媒体公告送达，公告60天期满，即视为送达。</p>
                    <p>4、如离职员工拒绝办理离职手续，或擅自离职行为造成无法办理离职手续，由法务部牵头，离职员工所在部门、财务部对其工作事项、物品、借支项、需赔偿项等进行核查，同时对其非正常离职给公司造成的损失进行评估，做出书面报告报董事长。</p>
                    <p>（三）合同期满离职</p>
                    <p>劳动合同期满前至少三十天，由人力资源部向员工所在部门负责人发出《续订劳动合同通知书》。</p>
                    <p>1、如员工在劳动合同期满不愿续签合同，员工应在《续订劳动合同通知书》中选择不续签劳动合同项并签名后，在劳动合同期满前二十八天将《续订劳动合同通知书》交给所在部门负责人。部门负责人在劳动合同期满前二十八天将《续订劳动合同通知书》交还人力资源部。人力资源部将《员工离职审批表》、《员工离职交接表》交离职员工办理离职手续。</p>
                    <p>2、如公司或部门在劳动合同期满后不愿续签合同，由员工所在部门负责人在《续订劳动合同通知书》中选择不续签合同项，签字后交公司人力资源部，由人力资源部填写《员工解除（终止）劳动合同通知书》并在劳动合同期满日前三十天与员工进行离职面谈。</p>
                    <p>二、离职审核规范及要求</p>
                    <p>（一）《员工离职审批表》经人力资源部相关人员审核后生效，并确定离职日期。离职申请未经批准人逐级签字同意不得办理后续离职交接手续。</p>
                    <p>（二）职级在6级以上（含6级）高管人员离职申请经批准后视情况由董事长决定是否需进行离职审计。如需进行离职审计，则在离职审计完毕后方可确定离职日。</p>
                    <p>（三）因员工原因给公司造成经济损失，在经济赔偿未处理完毕以前，不予办理离职手续。</p>
                    <p>三、员工离职社保关系转移规范及要求 </p>
                    <p>1、解除劳动合同之日即为社会保险费停缴月。</p>
                    <p>2、每月15日前离职者且离职手续办理完成交至人力资源部，社保于当月20前办理退保；若15日前离职者离职手续未按上述时间截点交至人力资源部，次月办理退保，且涉及相关费用根据实际情况由部门或个人自行承担；</p>
                    <p>3、岗位为维修、库房管理、物流驾驶等一线员工者，离职手续办理完成后，按交至人力资源部手续时间为准，人力资源部负责人对接并为其办理人身意外伤害保险退保手续。</p>
                    <p>4、员工离职后，人力资源部应按照社保办理的规定时间截点对接财务部办理离职员工社保停保事宜，按规定转移社保关系；如因未及时办理停保事宜导致社保费用产生，由经办人承担。</p>
                    <h3 name="0-2-0-2-7" className="point" id="0-2-0-2-7">3.8公司对离职员工的经济补偿</h3>
                    <p>一、经当事人双方协商一致解除劳动合同，由公司提出的，按《劳动合同法》和公司相关规章制度的规定办理，双方填写《解除劳动合同协议书》。</p>
                    <p>二、员工擅自离职、因员工过失被辞退等提前终止劳动关系的行为，公司不给予任何经济补偿。</p>
                    <p>三、离职员工未按要求办理离职手续，公司不给予任何补偿。</p>
                    <h3 name="0-2-0-2-8" className="point" id="0-2-0-2-8">3.9辞职员工对公司的赔偿</h3>
                    <p>一、由公司出资培训的员工，劳动合同期未满，因个人原因提出提前解除劳动合同关系时，按培训协议规定进行赔偿。</p>
                    <p>二、依法离职员工其薪资不足以冲抵其应支付款项，差额部分向公司进行赔偿。</p>
                    <p>三、员工擅自离职给公司造成损失的，按实际损失向公司进行赔偿。</p>
                    <p>四、按《劳动合同书》及附件所约定的赔偿规定进行赔偿。</p>
                    <p>五、离职员工拒绝赔偿，公司将依法向其提起诉讼，以维护公司的合法权益。</p>
                    <h3 name="0-2-0-2-9" className="point" id="0-2-0-2-9">3.10档案管理</h3>
                    <p>一、员工离司后，公司人力资源部将离职员工人事档案与在职人员人事档案分离。</p>
                    <p>二、离职员工人事档案及已经解除或者终止的劳动合同的文本保存时间自离职生效之日起，不得少于二年。</p>

                    <h3 name="0-2-0-2-10" className="point" id="0-2-0-2-10">3.11附 则</h3>
                    <p><strong>一、员工离职工作由人力资源部负责，各部门应全力配合人力资源部的工作，据实反映相关情况，以便人力资源部正确处理。</strong></p>
                    <p>
                        <strong>二、员工主动离职必须提供书面辞职申请，离职手续周期最长不得超过7个工作日（中层管理人员15日，高级管理人员30日），确有原因的，依据离职手续办理进度由直接责任人出具书面情况说明，据实陈述未能按期完成的原因（注：出差、调休、工作繁忙等不属于合理理由），人力资源部依据书面说明，合理延长期限，若无合理事由，人力资源部直接作出相关决定，因此产生的损失，由各管理公司、各部门承担。</strong>
                    </p>
                    <p>
                        <strong>三、员工出现违规违纪情况的，其直属领导应及时据实上报人力资源部，配合人力资源部工作，由人力资源部做出相应的决定，各部门任何人无权直接作出任何决定，且未经人力资源部授权，不得私自与员工商谈。</strong>
                    </p>
                    <p>
                        <strong>四、对于需要辞退的员工，各部门将书面说明、建议与相关材料一并上报人力资源部，由人力资源部负责与之协商，在进行电话沟通、面谈时，做好证据保全工作，各部门负责人未经人力资源部授权，不得私自与员工商谈。</strong>
                    </p>
                    <p>
                        <strong>五、人力资源部处理辞退事宜，需法务部介入协助的，应将与事件有关的全部资料及书面情况说明、解决意见转至法务部，由法务部参照意见书及事实材料作出处理意见回传人力资源部解决。</strong>
                    </p>
                    <p>
                        <strong>六、因特殊原因各管理公司、各部门需要自行解决的离职问题，由各管理公司、各部门作书面说明，报董事长签批后，方可自行处理，但不得违反法律法规及《员工手册》相关规定，待处理完毕及时报人力资源部备案。</strong>
                    </p>
                    <p><strong>七、人力资源部对解除劳动关系事宜负保密义务，离职员工档案（包括但不限于劳动合同、离职手续等）由人力资源部存档至少2年，到期方可作废。</strong></p>
                    <p>
                        <strong>八、发生劳动争议事件，由人力资源部通知原部门负责人将与案件有关的全部资料汇总至人力资源部，由人力资源将与案件有关的全部资料及书面情况说明、解决意见转至法务部（以上工作需在3日内完成）。</strong>
                    </p>
                    <p>
                        <strong>九、针对劳动争议事件，各部门应积极配合法务部的工作，根据法务部的需求，及时补充提供证据材料（收到法务部通知之时起48小时内），严禁拖沓推诿。不能提供的，由与证据材料直接相关的部门负责人自收到法务部通知之时起24小时内出具书面说明，详细阐明不能提供的原因。若法务部所需材料确需延期提供的，由部门负责人与法务部协商具体时间。</strong>
                    </p>
                    <p><strong>十、违反上诉规定，由人力资源部报公司董事会，董事会依据事件严重程度，对相关责任人做出经济处罚、降职降级等处罚措施。</strong></p>
                    <p><strong>本制度适用于公司职级在4级以上（含4级）的员工。</strong></p>
                    <h4>注：</h4>
                    <p>一、本制度由人力资源部拟定，董事长负责本制度制定、修改及审核。</p>
                    <p>二、离职相关管理流程细则，如涉及相关管理公司总经理及部门总监或经理未按此管理制度操作执行的，考核相关负责人500-1000分,并视情况而定承担相应的公司损失。</p>
                    <p>三、相关附件，如下汇总。</p>
                     <div><strong style={{color:'#6699FF'}}>附件1：</strong><a href="javascript:void(0);" type="primary" id='Enclosure38' title="《员工离职审批表》" onClick={(value)=>this.showDrawer(value)}>《员工离职审批表》</a></div>
                     <div><strong style={{color:'#6699FF'}}>附件2：</strong><a href="javascript:void(0);" type="primary" id='Enclosure39' title="《员工离职交接表》" onClick={(value)=>this.showDrawer(value)}>《员工离职交接表》</a></div>
                     <div><strong style={{color:'#6699FF'}}>附件3：</strong><a href="javascript:void(0);" type="primary" id='Enclosure310' title="《员工离职面谈表》" onClick={(value)=>this.showDrawer(value)}>《员工离职面谈表》</a></div>
                     <div><strong style={{color:'#6699FF'}}>附件4：</strong><a href="javascript:void(0);" type="primary" id='Enclosure311' title="《离职员工离职证明》" onClick={(value)=>this.showDrawer(value)}>《离职员工离职证明》</a></div>
                     <div><strong style={{color:'#6699FF'}}>附件5：</strong><a href="javascript:void(0);" type="primary" id='Enclosure312' title="《解除劳动合同通知书》" onClick={(value)=>this.showDrawer(value)}>《解除劳动合同通知书》</a></div>
                     <div><strong style={{color:'#6699FF'}}>附件6：</strong><a href="javascript:void(0);" type="primary" id='Enclosure313' title="《续订劳动合同通知书》" onClick={(value)=>this.showDrawer(value)}>《续订劳动合同通知书》</a></div>
                     <div><strong style={{color:'#6699FF'}}>附件7：</strong><a href="javascript:void(0);" type="primary" id='Enclosure314' title="《解除劳动合同协议》" onClick={(value)=>this.showDrawer(value)}>《解除劳动合同协议》</a></div>
                    {/* <p>附件1：员工离职审批表</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={lizhishenpibiao1} alt="" style={{width: '500px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件2：员工离职交接表</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={lizhijiaojiebiao1} alt="" style={{width: '900px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件3：员工离职面谈表</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={lizhimaintanbiao1} alt="" style={{width: '500px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件4：离职员工离职证明</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={lizhizhengming1} alt="" style={{width: '500px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件5：解除劳动合同通知书</p>

                    <p>附件6：续订劳动合同通知书</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={xudinglaodonghetong1} alt="" style={{width: '900px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={xudinglaodonghetong2} alt="" style={{width: '500px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <br/>
                    <p>附件7：解除劳动合同协议</p>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={jiechulaodonghetong1} alt="" style={{width: '500px',display:'block',margin:'0 auto'}}/>
                        </div> */}
                    <br/>
                    <br/>
                    <h4>钉钉系统流程图</h4>
                    <br/>
                        <div style={{textAlign:'center'}}>
                            <img src={ddlizhiliuchengtu} alt="" style={{width: '700px',display:'block',margin:'0 auto'}}/>
                        </div>
                    <h3 name="0-2-0-3" className="point" id="0-2-0-3">4、员工转正管理细则</h3>
                    <h3 name="0-2-0-3-0" className="point" id="0-2-0-3-0">4.1总 则</h3>

                    <h4>1、目的</h4>
                    <p>为规范员工试用转正考核流程，确保员工转正考核工作规范、有效、有章可循，特制定本办法。</p>
                    <h4>2、适用范围</h4>
                    <p>本制度适用于试用期转正新员工的考核。</p>
                    <h3 name="0-2-0-3-1" className="point" id="0-2-0-3-1">4.2转正考核管理规定</h3>
                    <h4>1、试用期内不符合公司要求者相关规定</h4>
                    <p><strong>1.1对于在试用期内不符合公司发展及岗位要求的、不能胜任岗位工作的员工</strong>，任用部门可随时将员工返回人力资源部，人力资源部可根据实际情况调整岗位或解聘。若聘用合同终止，公司不提供任何补偿。
                    </p>
                    <p>1.2对于在试用期有违反劳动合同及公司规章制度的员工，公司将依据实际情况和相关法律法规中的规定执行，监察部审查。</p>
                    <h4>2、员工试用期限相关规定</h4>
                    <p><strong>2.1新员工试用期原则上为3个月（有特殊规定的按规定执行）</strong>，人力资源部人事科每月26-28日依据转正规定为次月转正的员工，统一办理转正手续，即发起钉钉转正审批，各个负责人逐级审批通过后为转正通过。
                    </p>
                    <p><strong>2.2因员工个人原因导致未能在试用期内提供正常工作的，公司有权选择延长试用期或解除劳动关系。</strong></p>
                    <h4>3、试用期转正条件</h4>
                    <p>3.1 符合岗位任职资格要求，能够胜任岗位工作。</p>
                    <p>3.2 通过直接上级的考核，经审核合格。</p>
                    <p>3.3 认同公司企业文化，遵守公司各项管理制度，工作态度、工作任务完成符合要求，试用期间没有严重违纪和损害公司形象的行为。</p>
                    <p>3.4符合以上条件者方可办理转正手续。</p>
                    <h4>4、转正时间规定</h4>
                    <p>4.1 转正时间以每月15日为截点，集中办理转正手续。</p>
                    <p>4.2 入职时间≦16日者，于转正月当月办理相关手续；入职时间16日者，于转正月次月办理相关手续。</p>
                    <p>4.3若试用期满，公司仍认为该员工不能完全胜任工作，可经双方协商一致，酌情延长试用期，试用期的延长仅限一次。</p>
                    <h3 name="0-2-0-3-2" className="point" id="0-2-0-3-2">4.3转正考核流程</h3>
                    <h4>1、转正考核通知</h4>
                    <p>1.1 人力资源部于每月26-28日统计出次月可转正人员名单。</p>
                    <p>1.2 人力资源部人事科发起转正申请审批流程，各审批人逐级进行审批，审批通过后即视为转正手续完成。</p>
                    <h4>2、转正审批操作及时间截点规定</h4>
                    <p>2.1转正审批操作规定：</p>
                    <p>1、审批流程：</p>
                    <p>人力资源部人事科发起—部门经理/总监—转正员工本人—人力资源部人事科—人力资源部经理—各区域行政负责人</p>
                    <p>2、审批流程至部门经理/总监处：</p>
                    <p>（1）请填写 “部门总监/经理简评” 项，按要求填写该转正员工试用期间的工作表现；</p>
                    <p>（2）确认该员工是否可以办理转正手续，若转正，点击“同意”完成审批，并下载</p>
                    <p><div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure315' title="《岗位责任及收入分配协定书》" onClick={(value)=>this.showDrawer(value)}>《岗位责任及收入分配协定书》</a></div></p>       
                    <p>模板于转正月15日前与员工本人签署完成，并交至管理公司领导处审核签字确认；若不同意转正，点击“拒绝”完成审批，并填写拒绝意见。</p>    
                    <p>3、审批流程至转正员工处：</p>
                    <p>下载附件《试用期员工转正考核表》、《试用期员工转正试题》认真阅读并填写，找部门领导签字确认，与《转正岗位责任书》一起于转正月15日之前回传至钉钉审批并将原件送至人力资源部。操作：点击“同意”，选择“添加附件”，添加填写完成的上述附件，点击“同意”完成审批。</p>
                    <p><div><strong style={{color:'#6699FF'}}>附件1：</strong><a href="javascript:void(0);" type="primary" id='Enclosure316' title="《试用期员工转正考核表》" onClick={(value)=>this.showDrawer(value)}>《试用期员工转正考核表》</a></div></p>
                    <p><div><strong style={{color:'#6699FF'}}>附件2：</strong><a href="javascript:void(0);" type="primary" id='Enclosure317' title="《试用期员工转正试题》" onClick={(value)=>this.showDrawer(value)}>《试用期员工转正试题》</a></div></p>
                    <p>2.2 此审批流程须在转正月15日之前完成。</p>
                    <h3 name="0-2-0-3-3" className="point" id="0-2-0-3-3">4.4操作管理规定</h3>
                    <p>1、未按时间要求提交转正资料，导致转正延误者，如造成人事纠纷，直接对延迟流程部门责任人进行考核500-1000积分/次。</p>
                    <p>2、各级考核人员应严格把关，对申请人试用期间的表现进行客观评价，如有弄虚作假行为，一经查出，按照相关规定处理。</p>
                    <h4>3、有权限建议薪资调整（加薪、降薪）的部门负责人，必须严格按本管理办法的条款进行考核操作。</h4>
                    <h3 name="0-2-0-4" className="point" id="0-2-0-4">5、员工调动管理细则</h3>


                    <h4>第一条 总则</h4>
                    <p>为了加强员工调动管理，规范员工调动程序，使得各部门工作和人力资源达到最佳的匹配状态，特制定本制度。</p>
                    <h4>第二条 制度效力</h4>
                    <p>本制度只适用于员工在公司内部岗位调动的管理。</p>

                    <h4>第三条 岗位调动包含的内容</h4>
                    <p>(一)因公司需求要求员工调动，服从调动是员工的基本守则之一</p>
                    <p>（二）因个人提出调动申请被批准</p>
                    <p>(三)因其他原因导致员工岗位发生变动的</p>

                    <h4>第四条 员工调动程序</h4>
                    <p>1、员工本人或有调动需求的部门总监提报调动申请至人力资源部，人力资源部对调动人员及部门情况进一步了解并进行面谈。</p>
                    <p>2、员工本人、调出部门、调入部门、人力资源部四方协商调动事宜（调动后工作岗位职责及薪资构成等）；均无异议后提报钉钉系统至人力资源部办理调动手续。</p>
                    <p>2.1 员工钉钉系统发起调动申请；</p>
                    <p>2.2 原部门一级主管（科级）—原部门二级主管（总监/经理）—原部门三级主管（总经理级）—人力资部经理—人力资源部人事科执行并转交—现部门二级主管（总监/经理）—各区域行政负责人逐级依次进行审批：</p>
                    <p>2.3 调动员工办理原部门工作交接手续，保证各项交接事项的准确性、真实性。</p>
                    <p>2.4 调动后部门领导于调动当月与员工本人签署岗位责任书，并于调动当月20日前交至人力资源部审核存档。</p>
                    <p>3、调动前工作交接、调动后工作安排与相关责任人明确后，方可上岗。工作调动前与本人相关的原工作内容要负责到底。</p>

                    <h4>第五条 员工调动后薪资变动管理</h4>
                    <p>（一）因公司工作需要，公司对员工岗位进行平行(职级不发生变化)调动的。调动后薪资参照调动前薪资水平，原则上不低于调动前薪资水平。</p>
                    <p>（二）因员工个人原因提出调动的，调动后薪资参照调动前薪资水平以及调动后岗位薪等就近定薪，但不得高于调动后同类岗位最高薪资水平。</p>
                    <p>（三）因个人原因不能胜任目前岗位工作，发生岗位调动的。参照调动后同类岗位薪资情况定薪。</p>
                    <h4>第六条 员工未办理调动手续，不得随意调换工作岗位。对于违反员工调动规定者，按照违反公司规章制度处理，进行积分考核200-500分/次。</h4>
                    <h4>第七条 员工调动需由原部门办理工作、物品等交接手续，手续不清产生的相关责任根据实际情况由原部门或个人承担。原部门各项交接手续完成后，方可到新部门报到上岗。</h4>
                    <h4>第八条 本制度自公布之日起执行。</h4>
                    <h3 name="0-2-0-5" className="point" id="0-2-0-5"></h3>
                    <h2 name="0-2-1" className="point" id="0-2-1">二、考勤管理细则</h2>

                    <h3 name="0-2-1-0" className="point" id="0-2-1-0">1、总则</h3>
                    <h4>第一条 目的</h4>
                    <p>为加强考勤管理，维护工作秩序，提高工作效率，公司员工必须自觉遵守劳动纪律，按时上下班，不迟到，不早退，工作时间不得擅自离开工作岗位，特制定本制度。</p>
                    <h4>第二条 适用范围</h4>
                    <p>本规定适用于公司全体员工。</p>

                    <h3 name="0-2-1-1" className="point" id="0-2-1-1">2、考勤时间、打卡方法</h3>
                    <h3 name="0-2-1-1-0" className="point" id="0-2-1-1-0">2.1考勤工作时间</h3>
                    <p>上午：08：00 - 12：00 午休：12：30 - 13：30 下午：13：30 - 17：30</p>
                    <p>根据国家规定和公司工作业务量，各管理机构可有针对性地对工作时间进行统筹安排。午休时间如员工外出离开公司返家或去其他地方，必须向上级领导提报并说明原因；不在公司住宿的员工公司不提供休息床位；</p>
                    <p>经营机构（卡车管理公司、客车管理公司、配件管理公司、云豪车服延庆、云豪车服大兴）午休时间必须有值班人员，经营机构需根据本单位实际情况安排安排值班人员实现24小时无缝隙经营。</p>
                    <h3 name="0-2-1-1-1" className="point" id="0-2-1-1-1">2.2考勤打卡、补卡方法</h3>
                    <p>1、员工每天上下班均须打卡（即公司钉钉办公系统），人力资源部根据打卡记录追踪员工出勤情况。如打卡出现问题，由各部门统计报备人力资源部考勤核算人员。</p>
                    <p>2、正确打卡步骤：考勤打卡→必须先选择当天班次“上班或休息”（如调休或轮休，选择“休息”即可）→点击“上班打卡”确定→打卡；如未选择班次打卡，考勤出现“未排班并打卡”的当天考勤视为无效；选择“休息”后不需要在打卡，如考勤出现“休息并打卡”的视为当天休息；</p>
                    <p>3、因员工外出工作或加班情况导致第二天不能正常打卡的，在异常打卡时备注原因；外勤打卡时要备注外勤事由。</p>
                    <p>4、补卡方法:</p>
                    <p>如员工忘记打卡而按照正常时间上下班，由本人在打卡系统提报补卡申请并备注情况,直属上级负责人审批通过后当日未打卡记录抵消，考勤按正常出勤记录。</p>
                    <p>补卡规则：可申请3天之内的补卡，且每月可提交3次补卡申请。</p>

                    <h3 name="0-2-1-2" className="point" id="0-2-1-2">3、考勤奖惩机制</h3>
                    <h4>3.1 考勤奖励</h4>
                    <p>1、当月无请假、旷工且休息时间在4天以内（含4天），可得考勤奖励200分。当月无请假、旷工且无休，全月上班者可得全勤奖励400分；出勤率奖励上限为400分，（如休带薪假期，考勤按照实际出勤天数计算）。</p>
                    <p>2、上级领导临时指派或客户临时需求在休息日或工作日的17:30-22:00
                        22:00-06:00必须工作者，加班奖励20分/小时(不适用于已享有工时费的一线人员)；值班人员不另计加班奖励，值班时间在4小时之内算0.5天工作日，值班时间在4-8小时算1个工作日，值班时间超过8小时算1个工作日（加班和值班有着本质的区别）；在规定的、合理的工作时间没有完成工作而被动加班者，无价值加班扣50分/次；</p>
                    <h4>3.2 考勤扣罚</h4>
                    <p>1、员工每月一次迟到或早退不计入考勤扣罚；</p>
                    <p>2、上班或下班缺卡，扣50分/次；</p>
                    <p>考勤显示未打卡，扣100分/次/天；</p>
                    <p>员工打卡迟到、早退最高计时为2个小时，扣50分/次；</p>
                    <p>超过2个小时不到4个小时按照旷工半天计算，扣100分/次；</p>
                    <p>超过4个小时不到8个小时按照旷工一天计算；扣200分/次/天；</p>
                    <p>3、旷工一天，扣200分/次/天；旷工3天以上（含3天）的扣1天的双倍积分，旷工10天（含10天）以上的根据具体情况，由部门经理做出书面说明由人力资源部上报董事长做出批示后，针对当事人和所属部门经理做出处理，连续旷工7天（含）以上，或一年内累计旷工15天（含）以上，公司可以单方终止劳动合同关系，具体参照离职管理细则执行。</p>
                    <p><strong>注明：收入构成：职级工资+固定积分收入+动态积分收入+突出贡献补贴+年终奖金+业绩提成+创业空间+承包收益+合伙人分红+年薪+实股</strong></p>

                    <h4>3.3 请假流程及薪资计算</h4>
                    <p>1、病假</p>
                    <p>（1）员工请病假需提前提交《请假申请》并准确说明请假理由，如因临时身体情况当天请病假需电话或口头提前向主管领导审批，当天在钉钉办公系统提交《请假申请》，上级领导审批；</p>
                    <p>（2）病假薪资计算按100分/次/天。超过1个月的病假需提供正规医院病假条，由所在部门经理上报人力资源部，经董事长批复后根据个人实际情况发放基本生活费，病假期间发放职级工资的50%；病假最长3个月，超过3个月视情况解除劳动合同。</p>
                    <p>2、事假</p>
                    <p>（1）员工请事假需提前钉钉系统提交《请假申请》并准确说明请假理由，如因特殊情况当天请事假需及时提交《请假申请》并及时以电话或口头提前向主管领导审批及人力资源部审批通过后生效；</p>
                    <p>（2）事假薪资计算按100分/次/天；事假不提前提报并批准的按旷工处理；</p>
                    <p>（3）员工因实际困难请事假超过1个月的，由部门经理上报人力资源部，经批复后提交停薪留职申请，办理停薪留职相关手续及工作交接；事假最长3个月，超过3个月视情况解除劳动合同，具体情况具体处理。</p>
                    
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure320' title="《员工停薪留职申请表》" onClick={(value)=>this.showDrawer(value)}>《员工停薪留职申请表》</a></div>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure321' title="《停薪留职协议》" onClick={(value)=>this.showDrawer(value)}>《停薪留职协议》</a></div>
                    <p></p>

                    <p>（4）任何请假必须有主管领导的文字同意信息（请假审批、微信、信息回复均可），如领导不知情或未回复、未审批的请假按旷工处理。</p>
                    <h3 name="0-2-1-3" className="point" id="0-2-1-3">4、特殊考勤情况</h3>
                    <h3 name="0-2-1-3-0" className="point" id="0-2-1-3-0">4.1出差</h3>
                    <p>员工外出工作大于1个工作日的即为出差，出差的员工在钉钉审批系统中提交出差申请，考勤核算时按出差计算，出差申请需要在出差3日内提交，如未及时提交，根据“考勤奖惩机制”，按实际考勤情况核算（考勤显示旷工或未打卡按照对应奖惩规定计算）。</p>
                    <h3 name="0-2-1-3-1" className="point" id="0-2-1-3-1">4.2外勤</h3>
                    <p>员工因工作需要在非办公地点打卡即为外勤，外勤打卡与正常打卡要求一致，还需备注外勤事由，外勤考核与正常考核一致，参照“考勤奖惩机制”执行。</p>
                    <h3 name="0-2-1-3-2" className="point" id="0-2-1-3-2">4.3驻站</h3>
                    <p>因工作需要安排异地长期或短期工作的为驻站，半年之内的驻站为短期驻站，短期驻站申请出差即可，半年以上的驻站为长期驻站，长期驻站的员工按照正常打卡要求进行考勤。</p>
                    <h3 name="0-2-1-4" className="point" id="0-2-1-4">5、其他说明</h3>
                    <h4>第十一条 说明</h4>
                    <p>1、员工请假需提前向上级部门领导逐级审批，并事先在钉钉办公系统上提交请假申请，不得假后上班再补填，实际离岗时间以打卡系统为准，如员工未及时提交请假申请，考核扣除部门负责人200分；</p>
                    <p>2、由于特殊原因员工造成先行离岗未提交请假申请，请部门经理及时告知人力资源部，如部门未及时上报，另考核扣除部门负责人500分；如员工请假没有按照规定提交请假申请，且部门经理也没有向人力资源部告知该员工请假事宜的则按照旷工处理，由部门经理与员工自行承担。</p>
                    <p>3、如丧假、病假、中途续假等不及时补报，中间未出勤的日期一律按照旷工处理，旷工的当事人自行承担；</p>
                    <p>4、员工轮休时考勤系统班次选择“休息”即可，月底统计考勤时将根据员工具体的请假天数确定是否扣除日薪(是否超过正常月度休息天数)，人力资源部会进行核实，如没有超过正常休息天数，员工轮休天数将会被冲抵并正常发薪。</p>
                    <p>5、公司国内外派机构及人员参照本规定执行,国外外派机构及人员参照当地国家的法律、法规并视具体项目情况而定。</p>
                    <h2 name="0-2-2" className="point" id="0-2-2">三、福利休假管理细则</h2>
                    <h3 name="0-2-2-0" className="point" id="0-2-2-0">1、总则</h3>
                    <h4>第一条 目的</h4>
                    <p>为规范公司福利休假管理制度，明确员工享受的福利及假期，使福利休假更加科学合理化，特制定本制度。</p>
                    <h4>第二条 适用范围</h4>
                    <p>本规定适用于公司全体员工</p>
                    <h3 name="0-2-2-1" className="point" id="0-2-2-1">2、保险、休假、福利种类</h3>
                    <h4>第三条 保险、休假、福利明细一览表</h4>
                    <br/>
                    <img src={fuliyulanbiao} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h3 name="0-2-2-2" className="point" id="0-2-2-2">3、保险、休假规定</h3>
                    <h4>3.1 保险类</h4>
                    <h4>1、社会保险</h4>
                    <p>按照国家规定为每位签订劳动合同的员工缴纳社会保险。 </p>
                    <h4>2、商业保险</h4>
                    <p>公司根据员工工作的性质和工种出资为特定人员补充一定险别的商业保险。 </p>
                    <h4>3.2 休假类</h4>
                    <h4>3.2.1 法定假</h4>
                    <p>根据国家法定标准及公司实际情况安排，员工可以享受元旦、春节、清明节、“五一”国际劳动节、端午节、中秋节、国庆节带薪假期。</p>
                    <h4>3.2.2 年假</h4>
                    <p>适用范围：本规定适用于与本公司签订正式劳动合同的正式员工。</p>
                    <p>3.2.1 年休假享受对象 ：</p>
                    <p>在本公司连续工作12个月以上的员工可享受带薪年休假。 </p>
                    <p>3.2.2 年休假时间</p>
                    <p>员工根据在本公司不同的工作年限享受不同的休假时间：</p>
                    <p>3.2.2.1 连续工作满1年不满10年的，年休假5天；</p>
                    <p>3.2.2.2 连续工作满10年不满20年的，年休假10天；</p>
                    <p>3.2.2.3 连续工作满20年的，年休假15天，最长年休假15天；</p>
                    <p>3.2.2.4 海外工作员工连续在海外工作满11个月可享受30天休假（含路途时间），休假期间只享受基本工资无境外补助。外派连续工作不满11个月属国际出差，不享受海外人员休假制度，与国内人员休假制度同步。</p>
                    <p>3.2.3 年休假计算方式</p>
                    <p>3.2.3.1 员工连续工作满一年不足一个自然年：年休假计算方式为<strong>(工作满一年后当年在本单位已过自然年天数÷365)×职工本人全年度应享受年休假天数=本年年休假天数。如小张2016年7月20日入职，2017年7月20日满一年，2017年享受的年休假天数为：(164÷365)×5=2.25
                        其中0.25不足一天，年休假为2天。</strong></p>
                    <p>3.2.3.2 员工连续工作满一年且满一个自然年，每自然年享有5天年假。如小张2016年7月20日入职，2017年7月20日满一年，2018年1月1日起，每自然年享有5天年假。</p>
                    <p>3.2.3.3 员工连续工作满10年、20年，计算方式同2.3规定。</p>
                    <p>3.2.4 有下列情形之一的，不享受当年的年休假：</p>
                    <p>3.2.4.1 连续工作满1年不满10年的员工，休病假、事假年累计2个月以上的；</p>
                    <p>3.2.4.2 连续工作满10年不满20年的员工，休病假、事假年累计3个月以上的；</p>
                    <p>3.2.4.3 连续工作满20年的员工，休病假、事假年累计4个月以上的；</p>
                    <p>3.2.4.4 员工已享受当年的年休假，年度内又出现以上三条规定情形之一的，不享受下一年的年休假；</p>
                    <p>3.2.5 年假期限</p>
                    <p>年假有效期为一个自然年，一个自然年内必须休完，不得转移到下一年，因工作需要未及时休假的，根据未休年假天数给予相应补助（自然年：2019年1月1日-2019年12月31日）。</p>
                    <p>3.2.6 年假休假注意事项</p>
                    <p>考虑到我公司外地人员占比较大，特批春节假期在法定7天的基础之上可额外最多连休4天年假，即春节假期最长休假不超过11天。若年假全部休完，则春节假期需按照法定7天休假，超出休假天数按事假计算。 </p>
                    <p>例如：张三 2019
                        年1月1日起每自然年可享受5天带薪年假，截止目前已休3天年假，则2019年春节假期（2020年1月24日）可在法定假7天基础上再额外休2天年假，然后回到工作岗位；或者张三在
                        2019年春节假期（2020年1月24日）之前5天年假全部休完，则春节需按法定假7天进行安排，然后回到工作岗位。</p>
                    <h4>3.3 婚假（包括路程假）</h4>
                    <p>1、按照法律规定结婚的，婚假3天+增加假7天=10天。 </p>
                    <p>2、 婚假必须在登记之日起一年内休完；</p>
                    <p>3、申请婚假需提供登记一年之内的结婚证；</p>
                    <p>4、婚假须至少提前1周申请，经部门总监/经理同意及人力资源部批准后方可休假，且一次休完，不得分期休假。</p>
                    <h4>3.4 孕检假</h4>
                    <p>女员工怀孕至生产前，每月享有1天孕检假，为便于人力资源部管理，申请孕检假时需提供孕检证明。</p>
                    <h4>3.5 产假</h4>
                    <p>1、女职工合法生育的享受98天产假，奖励假30天；难产的，增加产假15天。生育多胞胎的，每多生育1个婴儿，增加产假15天。</p>
                    <p>2、女职工怀孕≦16周流产的，享受15天产假。怀孕16周以上流产的，享受42天产假（以医院诊断证明为准）。</p>
                    <p>3、产假期间工资按照基本工资（职级工资+固定积分收入）发放，产假结束后一周之内按照法定的社保报销流程办理相关手续（产假以自然日计算）。</p>
                    <p>4、申请产假时请提供结婚证明、生产证明；如难产的提供难产证明。</p>
                    <h4>3.6 哺乳假</h4>
                    <p>女员工自产假结束后至婴儿满1周岁期间，单胎婴儿工作日每天享有1小时哺乳假时间，每增加一胎，增加1小时。为便于合理安排工作，每天哺乳假时间不得拆分休息，假期期间需固定时间休息。</p>
                    <h4>3.7 陪产假</h4>
                    <p>1、因配偶合法生育子女的，男职工享受十五天陪产假（陪产假以自然日计算）；</p>
                    <p>2、陪产假须至少提前1周申请，经部门领导同意及人力资源部批准后方可休假，且一次休完，不得分期休假。</p>
                    <p>3、申请陪产假需提供结婚证明、出生证明。</p>
                    <h4>3.8 丧假</h4>
                    <p>员工的直系亲属死亡时根据具体情况酌情给予3天的丧假，直系亲属包括父母、配偶和子女。如果员工死亡的直系亲属在外地，需要员工本人去外地料理丧事的根据路程远近给予一天路程假。非直系亲属的婚丧嫁娶原则上不准假，既成事实按事假处理。</p>
                    <h4>3.9 工伤假</h4>
                    <p>1、员工因工作遭受事故伤害或者患职业病进行治疗，享受工伤医疗待遇。</p>
                    <p>2、停工留薪期一般不超过12个月。伤情严重或者情况特殊，经劳动能力鉴定委员会确认，可适当延长，但延长不得超过12个月。</p>
                    <p>3、工伤员工评定伤残等级后，停发原待遇，享受伤残待遇。工伤职工在停工留薪期满后仍需治疗的，继续享受工伤医疗待遇。</p>

                    <h3 name="0-2-2-3" className="point" id="0-2-2-3">4、休假待遇、安排</h3>
                    <h4>4.1 休假待遇</h4>
                    <p>1、年休假期间，员工基本工资（职级工资+固定积分收入）全额计发。</p>
                    <p>2、员工在休假期间的月度工作考核，无特殊情况视作考核合格，并作为年度考核依据。</p>
                    <p>3、休假期间，员工其他福利发放享受在岗员工待遇。</p>
                    <h4>4.2 休假安排</h4>
                    <p>1、公司根据各管理公司/中心及事业部的生产及服务工作的特点和员工本人的具体情况，统筹安排员工的休假。</p>
                    <p>2、员工申请休假需提前办公系统办理申请并由管理公司/中心总经理批准。</p>
                    <p>3、员工休假一次性最长不超过6天（含周六日和法定节假日），不允许连带周六日、法定节假日同时休假。</p>
                    <p>4、休假在一个自然年度内安排，每年12月31日自动清零，不可累积至下一自然年；</p>
                    <p>5、休假一般安排在不能影响正常生产的时期，可集中安排也可分段安排（婚/丧/产/陪产假除外）。</p>
                    <p>6、因工作不能安排员工休假，工作期间的劳动报酬按正常职级工资发放；如单位安排休假但员工因本人原因且书面提出不休年假的，视为员工自愿放弃年休假，无需支付补偿性工资报酬。</p>
                    <p>7、若员工本人申请休假的，必需经部门负责人及集团副总领导批准，未经批准先休息后申请休假的，按事假处理。</p>
                    <p>8、年休假期间遇法定节假日，节假日不计算在年休假天数内。</p>
                    <p>9、员工可用年休假时间抵消病假、事假天数，请假期间工资待遇可按照年休假待遇执行。</p>
                    <p>10、实行年薪的人员，不享受年休假的补偿政策。</p>
                    <h3 name="0-2-2-4" className="point" id="0-2-2-4">5、福利</h3>
                    <h4>5.1 节日、通讯福利</h4>
                    <p>国家法定节假日公司根据情况给予员工一定数额的过节费用补贴。具体标准如下：</p>
                    <p>1、春节、“十·一”按每个节日人均xxx元标准，发放实物礼品或购物卡；</p>
                    <p>2、元旦、“五·一”、端午节、中秋节按xxx元/人标准,购赠节日礼物；</p>
                    <p>3、“三八”妇女节按xxx元/人标准向女员工,购赠节日礼物；</p>
                    <p>4、 员工生日，为其送上生日贺卡或购买具有纪念意义的实用价值的礼物；</p>
                    <p>5、防暑降温费公司员工按每年xxx元/人标准、劳务员工xxx元/人标准；</p>
                    <p>6、通讯费报销，视岗位及业务给于不同的电话卡及话费补贴。</p>
                    <p>7、上述节日福利标准由董事会临时决定。</p>
                    <h4>5.2 职业装</h4>
                    <p>1、职业装包括：技师服、仓储物流工服、销售正装、客服接待正装、冬季/夏季时装、户外装、休闲装、劳保鞋、领带、围脖、帽子、手套、衬衣、背包、手表、办公用品、生活用品等。</p>
                    <p>2、要求：员工穿着对应岗位的职业装是云豪集团对每一位员工的基本规范之一，员工的职业形象是衡量本人是否是云豪合格员工的基本要素之一。监察部、行政部会对每一位员工关于职业装的规范做出积分考核。公司将有偿提供不同规格、不同品类的云豪职业装。职业装是由品质优良的生产厂家定制生产，贴云豪或代理品牌LOGO，“云豪礼品店”也由此产生。“云豪礼品店”的所有礼品对内部员工只收取成本价的50%，云豪员工亦可用相应积分购买。</p>
                    <p>3、购买渠道:详见“云豪礼品店”明细。</p>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure318' title="《云豪礼品店》" onClick={(value)=>this.showDrawer(value)}>《云豪礼品店》</a></div>
                    <p></p>
                    <h4>5.3 年度体检</h4>
                    <p>公司每两年为员工提供一次常规体检，费用由公司承担。具体由行政副总裁统筹安排。</p>
                    <h4>5.4 购车、购房补贴</h4>
                    <p>员工符合一定条件可按照公司规定给予购车和购房补贴，具体数额和标准参照“积分制-积分痕迹”。</p>
                    <h4>5.5 境内/境外旅游</h4>
                    <p>员工符合一定条件可按照公司规定给予购车和购房补贴，具体数额和标准参照“积分制-积分痕迹”。</p>
                    <h4>注：</h4>
                    <p>境外旅游：每年集团公司将会免费奖励5-8个名额（可携带1名家属）赴北欧或东南亚旅游；</p>
                    <p>境内旅游：奖励8-10个名额（可携带1名家属）赴新疆或国内旅游胜地旅游；</p>
                    <h4>主要奖励对象为获得上一年度集团公司各级别优秀员工。</h4>
                    <h4>5.6 团队建设</h4>
                    <p>公司为丰富全体员工业余文化生活、增进团体凝聚力、增广见闻，每年不定期安排员工活动，全部费用由公司负担。</p>
                    <p>在不影响本职工作的前提下，挖掘自身特长、潜力用于集团公司内部的文体学习活动，为集团公司营造快乐工作氛围做出贡献。对组织者0-500积分/次奖励，由人力资源部鉴定。</p>
                    <h2 name="0-2-3" className="point" id="0-2-3">四、劳动合同/人事档案管理细则</h2>
                    <h3 name="0-2-3-0" className="point" id="0-2-3-0">1、劳动合同管理细则</h3>
                    <h3 name="0-2-3-0-0" className="point" id="0-2-3-0-0">1.1总 则</h3>
                    <p>
                        <strong>第一条</strong> 为进一步加强和完善公司员工劳动合同管理，根据《中华人民共和国劳动法》、《中华人民共和国劳动合同法》及国家有关政策、法规的规定，结合公司实际，制定本办法。
                    </p>
                    <p><strong>第二条</strong> 劳动合同是劳动者与用人单位之间确立劳动关系，明确双方权利与义务的协议。</p>
                    <p><strong>第三条</strong> 集团人力资源部负责全公司劳动合同的签订、审核等管理工作。</p>
                    <p><strong>第四条</strong> 本管理办法适用于集团公司在册职工。</p>
                    <h3 name="0-2-3-0-1" className="point" id="0-2-3-0-1">1.2劳动合同的订立和履行、变更</h3>
                    <p><strong>第五条</strong> 劳动合同的签订分为新签和续签两种，</p>
                    <p>新签劳动合同是指公司招聘录用、外单位调入员工时签订的劳动合同；</p>
                    <p>续签劳动合同是指劳动合同期满续延签订劳动合同。</p>
                    <p><strong>第六条</strong> 劳动合同的期限分为固定期限、无固定期限和以完成一定工作任务为期限三种形式。</p>
                    <p> (一) 经劳动合同双方当事人协商一致，可以选择任何一种形式的劳动合同。</p>
                    <p>（二）新签劳动合同的期限一般为四年；续签劳动合同的期限一般为五年，特殊情况由公司与员工平等协商确定。</p>
                    <p>（三）公司新签劳动合同中员工试用期限为三个月。</p>
                    <p><strong>第七条 劳动合同变更</strong>由于情况发生变化，经劳动合同当事人双方协商一致，可变更劳动合同的部分条款，变更项目较多时，可重新签订劳动合同。
                    </p>
                    <h4>第八条 劳动合同续签工作流程</h4>
                    <p>1、劳动合同期限届满前，由集团人力资源部提前45天对劳动合同即将到期的员工发起续签的钉钉逐级审批流程，审批结束后在合同即将到期的30日以内对于审批结果及时反馈至员工并做好后续工的相关工作，工作流程如下：</p>
                    <p>人力资源部按月清点劳动合同花名册→合同到期前一个月发起审批→人力资源部于合同到期前一个月钉钉发起通知至员工→员工在合同到期前20天提出续签意见并回传至钉钉→人力资源部汇总审核填写《续签劳动合同登记表》→续签员工于20日内至人力资源部进行续签→公司人力资源部审核→审核无误的劳动合同进行盖章→公司存档。</p>
                    <p>劳动合同续签流程需严格按照上述流程逐级执行审批，并明确填写审批意见，如有审批延误或审批意见描述不清晰致使劳动合同延误签署或产生人事纠纷的，依据实际情况产生的后果，对相应责任人进行考核200-1000积分/次。</p>
                    <p>2、员工在规定的医疗期内或者女职工在孕期、产期、哺乳期内，劳动合同期限届满时，公司人力资源部应当将劳动合同的期限顺延至医疗期、孕期、产期、哺乳期期满为止再进行续签审批工作。</p>
                    <p>3、续签劳动合同签订的终止日同样以原合同最后的月、日相对应。</p>
                    <p>4、合同期满离职的员工，如员工在劳动合同期满不愿续签合同，员工应在《续订劳动合同通知书》中选择不续签劳动合同项并签名后，在劳动合同期满前28天将《续订劳动合同通知书》交给所在部门负责人。部门负责人在劳动合同期满前28天将《续订劳动合同通知书》交还人力资源部。人力资源部将《员工离职审批表》、《员工离职交接表》交离职员工办理离职手续。</p>
                    <p>5、如公司或部门在劳动合同期满后不愿续签合同，由员工所在部门负责人在《续订劳动合同通知书》中选择不续签合同项，签字后交公司人力资源部，由人力资源部填写《员工解除（终止）劳动合同通知书》并在劳动合同期满日前三十天与员工进行离职面谈。</p>
                    <h3 name="0-2-3-0-2" className="point" id="0-2-3-0-2">1.3劳动合同终止和解除</h3>
                    <p><strong>第九条</strong> 有下列情形之一的，劳动合同终止：</p>
                    <p>（一） 劳动合同期满的；</p>
                    <p>（二）员工开始依法享受基本养老保险待遇的；</p>
                    <p>（三）员工死亡，或者被人民法院宣告死亡或者宣告失踪，劳动合同即行终止。</p>
                    <p>（四）企业主体资格消亡的；</p>
                    <p>（五）法律、行政法规规定的其他情形。</p>
                    <p><strong>第十条</strong> 有下列情形之一的，员工可以与公司解除固定和无固定期限劳动合同：</p>
                    <p>（一）员工预告解除，指员工提前三十日以书面形式通知公司，可以解除劳动合同。员工在试用期内提前三天通知公司，可以解除劳动合同。</p>
                    <p>（二）未按照劳动合同约定提供劳动保护或者劳动条件的；</p>
                    <p>（三）公司的规章制度违反法律、法规的规定，损坏劳动者权益的；</p>
                    <p>（四）由于公司原因致使劳动合同无效的；</p>
                    <p>（五）法律、行政法规规定员工可以解除劳动合同的其他情形。</p>
                    <p><strong>第十一条</strong> 有下列情形之一的，公司可与员工解除固定和无固定期限劳动合同：</p>
                    <p>（一）员工患病或者非因工负伤，在规定的医疗期满后不能从事原工作，也不能从事由公司另行安排工作的；</p>
                    <p>（二）员工不能胜任工作，经过培训或者调整工作岗位，仍不能胜任工作的；</p>
                    <p>（三）劳动合同订立时所依据的客观情况发生重大变化，致使劳动合同无法履行，经公司与员工协商，未能就变更劳动合同内容达成协议的。</p>
                    <p>（四）在试用期间被证明不符合录用条件的；</p>
                    <p>（五）严重违反公司的规章制度；</p>
                    <p>（六）严重失职，营私舞弊，给公司造成重大损害的；</p>
                    <p>（七）公司员工同时与其他用人单位建立劳动关系，对完成公司的工作任务造成严重影响，或者经公司提出，拒不改正的；</p>
                    <p>（八）由于员工本人原因致使劳动合同无效的；</p>
                    <p>(九) 被依法追究刑事责任的。</p>
                    <p>
                        <strong>第十二条</strong> 为规范劳动合同的管理，对员工严重失职、营私舞弊、给公司造成重大损害的情形按《中华人民共和国劳动法》、《中华人民共和国劳动合同法》及国家有关政策、法规的规定规定执行。
                    </p>
                    <p>
                        <strong>第十三条</strong> 根据《公司员工考勤管理办法》相关规定，对擅离工作岗位，连续旷工7天（含）以上，或一年内累计旷工15天（含）以上，公司给予解除劳动合同处理；给公司造成经济损失的，并依法追究赔偿责任。
                    </p>
                    <p>
                        <strong>第十四条</strong> 公司员工未按《劳动法》或《劳动合同法》的相关规定，单方面解除劳动合同，给公司造成经济损失的，须按其造成的经济损失支付赔偿金。
                    </p>
                    <h3 name="0-2-3-0-3" className="point" id="0-2-3-0-3">1.4劳动合同的日常管理</h3>
                    <p><strong>第十五条</strong> 公司人力资源管理部负责人员在工作中要做好劳动合同政策宣传，认真按程序办事，建立、完善劳动合同管理台帐。</p>
                    <p><strong>第十六条</strong> 劳动合同到期的在岗员工，所属部门要对其在履行劳动合同期间的工作表现进行考核，不适应继续工作的坚决予以终止。</p>
                    <p><strong>第十七条</strong> 劳动合同到期的不在岗员工，要予以终止，特殊原因可本人申请，所属部门同意，公司主管领导批准，续订有固定期限的劳动合同。
                    </p>
                    <p><strong>第十八条</strong> 员工违反国家法律法规及公司规章制度，符合除名或解除劳动合同条件的，要予以除名或解除劳动合同。</p>
                    <h3 name="0-2-3-0-4" className="point" id="0-2-3-0-4">1.5附 则</h3>
                    <p><strong>第十九条</strong> 合同签署户别</p>
                    <div><strong style={{color:'#6699FF'}}> 附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure319' title="《合同签署户别》" onClick={(value)=>this.showDrawer(value)}>《合同签署户别》</a></div>
                    <p></p>
                    <p><strong>第二十条</strong> 公司与员工发生劳动争议，按国家有关劳动争议的规定处理。</p>
                    <p><strong>第二十一条</strong> 本办法未尽事宜，按国家及省、市有关规定执行。本办法由公司人力资源部负责解释。</p>
                    <h3 name="0-2-3-1" className="point" id="0-2-3-1">2、人事档案管理细则</h3>
                    <h4>第一条 总则</h4>
                    <p>为了规范公司劳动人事档案管理工作，对人事档案进行妥善保管，维护人事档案材料的完整性，防止材料损坏和遗失，以及便于人事档案材料的使用，为人力资源管理工作提供有效的信息依据，特制定本管理办法。</p>
                    <h4>第二条 适用范围</h4>
                    <p>员工人事档案日常管理。</p>
                    <h4>第三条 管理原则</h4>
                    <p>安全、保密、清晰、完整。</p>
                    <h4>第四条 管理职责</h4>
                    <p>由人力资源部（人事科）负责按本管理办法对公司所有员工的人事档案进行管理。</p>
                    <h4>第五条 管理程序</h4>
                    <h4>（一）人事档案建立</h4>
                    <p>新员工入职之日，由人力资源部（人事科）为其建立一个独立的人事档案。人力资源部首先对档案材料进行收集和整理，若收集的是复印件必须与原件对照审验，准确无误后进行归档。</p>
                    <p>人事档案包括但不限于以下资料：</p>
                    <p>1、身份证复印件（正反面复印在同一张A4纸上）。</p>
                    <p>2、证书复印件，证书包括职业资格证书、职称证书、学历及学位证等。</p>
                    <p>3、审核其应届生身份或离职状态的相关证明。</p>
                    <p>4、近期个人免冠照片2张（底色不限）。</p>
                    <p>5、应聘人员登记表（包括附带的个人简历）以及员工入职档案登记表。</p>
                    <p>6、县区级以上医院体验合格证明。体检项目包括但不限于：血常规、胸部透视、心电图、肝功能。</p>
                    <p>7、法规规定的特殊岗位，应有职业资格或从业资格证书复印件（原件应审验）。</p>
                    <p>8、<strong>《新员工入职告知书》、《入职声明书》、《员工入职登记表》、《劳动合同》或《劳务协议》，以及《保密协议》和《承诺函》正本各一份。</strong>
                    </p>
                    <p>9、背景调查表（主管及以上岗位，出纳及关键核心岗位）及录用审批表。</p>
                    <p>10、员工手册签收单即入职指引手册培训。</p>
                    <h4>（二）人事档案资料的添加</h4>
                    <p>以下类别信息，由人力资源部档案保管专员在收到资料后添加到其本人人事档案中：</p>
                    <p>1、人员转正申请审批表及相关转正材料及考核资料。</p>
                    <p>2、员工与公司补充签订的各种重要的个人申请、承诺、协议、保险等材料。</p>
                    <p>3、员工岗位（职务）变动调整通知书。</p>
                    <p>4、员工考勤类材料。</p>
                    <p>5、员工薪资变动资料。</p>
                    <p>6、员工岗位责任书及收入构成</p>
                    <p>7、员工晋升、各种处分、处罚材料和通报批评等奖惩类相关资料。</p>
                    <p>8、员工变更的个人资料。</p>
                    <p>9、员工劳动合同续签意见征询单。</p>
                    <p>10、员工离职申请、离职审批表、离职交接手续等记录。</p>
                    <p>11、终止劳动关系通知书员工签收回执。</p>
                    <p>12、其他需添加的资料。</p>
                    <h4>（三）人事档案的其他专项保管</h4>
                    <p>考虑部分专项工作特殊情况，以下类别由各业务负责人提供相关人事档案材料作专项保管。</p>
                    <p>1、员工考核考察资料，包括月度考核、年度考核、晋升考察等资料。</p>
                    <p>2、员工培训申请、培训记录、培训心得、培训效果评估等与培训相关的资料及考核相关资料。</p>
                    <p>3、其他需单项保管材料。</p>
                    <h4>（四）人事档案编号</h4>
                    <p>1、公司人事档案统一按云豪系统员工工号编号。</p>
                    <p>2、员工离职后，其档案从在职档案中取出归入离职人员档案，但档案编号保持不变，仍采用原工号编号。</p>
                    <h4>（五）人事资料的定期更新与维护</h4>
                    <p>1、员工有调动、考评、奖惩等人事动态时，及个人资料有变化时，人事档案管理人员应及时进行记录或修改，确保人事档案的正确性。</p>
                    <p>2、为确保员工人事资料的有效性，可由所在部门统计建立本部门员工基础档案，员工一旦有个人信息资料（身份证号、联系方式、家庭住址、户籍地、学历、职称、岗位等）更新，则按最新个人信息更新人事和人事数据系统，并统一在规定时间前以电子文档和纸质材料同时报送所在集团公司人力资源部（人事科）。</p>
                    <h4>（六）人事档案的查阅</h4>
                    <p>1、人事档案为公司密件，也是员工个人的私隐资料，人力资源部必须合理存放，严格执行程序。员工档案资料是保密的，原则上只有公司领导及人事保管人员方可查阅，员工不能查阅其他人员的档案，各级管理人员只可查阅其部门下属员工的人事档案，特殊情况经审批后方可调阅。</p>
                    <p>2、员工人事档案属保密级文件，原则上不允许借阅（借出），一般采取在人力资源部（人事科）人事档案保管人员的陪同下查阅的方式。各级管理人员查阅本部门下属员工的个人档案时，必须为员工个人资料情况保密。</p>
                    <p>3、如有特殊原因需借阅员工档案时，遵循以下规定执行：</p>
                    <p>（1）由申请查阅者提报人力资源部负责人说明查阅的对象，目的，理由，查阅人的概况等情况。</p>
                    <p>（2）人力资源部经理同意后报人事科主管登记、备案。</p>
                    <p>（3）按审批权限批准后，人事科办理借阅登记手续才可借出。</p>
                    <p>（4）借阅时间以规定时间为限，不得转借，拆卸、调换、复印。</p>
                    <p>（5）归还时，由人力资源部（行政人事部）核对档案资料归还是否完整。</p>
                    <p>4、借阅员工档案时须满足一定的条件</p>
                    <p>（1）本管理公司领导需要查阅人事档案；</p>
                    <p>（2）公安、保卫部门因特殊需要必须借用人事档案等。借出的时间不宜过长，到期未还者应及时催还。</p>
                    <p>（3）出具证明材料。这也是人事档案的功能之一。出具的证明材料可以是按有关文件规定写出的有关情况的证明材料，也可以是人事档案材料的复制件。要求出具材料的原因一般是入党、入团、升迁、子女入学、出国等。</p>
                    <h4>（七）人事档案资料的复印</h4>
                    <p>1、如因公司业务需要复印员工的身份证、学历证明、职业资格证明等个人证照复印件，与上述（六）人事档案的查阅的规定执行，按借阅人事审批权限批准后方可调用。</p>
                   
                    <p>2、如因员工要求复印个人人事档案资料，除属于由员工本人提供的原始人事档案资料外，其他由人力资源部（人事科）添加的人事档案资料不得复印、查阅或借阅。</p>
                    <h4>（八）人事档案的保存</h4>
                    <p>1、人力资源部必须对人事档案的保存地点、环境等作出评估，以确保人事档案的存放安全。</p>
                    <p>2、无论在职员工或离职员工，已建立的人事档案任何资料不得退还员工本人。</p>
                    <p>3、在职员工的人事档案将一直保存；离职员工的人事档案原则上保存期自离职日起至少两年备查。</p>
                    <p>4、属于公司解除（终止）劳动合同、辞退、自动离职等类别员工，其人事档案（应注意考勤、奖惩、考核、情况说明等资料）应特别审查后特别重点保存。</p>
                    <p>5、按规定销毁的档案由人事档案保管人填写销毁申请单，经人力经理审核批准，并指定人员执行销毁。审核、批准、执行人员要在销毁申请单上签字，并存档案。</p>
                    <h4>（九）人事档案管理信息化</h4>
                    <p>1、为提高人事管理工作效率，公司将逐步建立人事档案信息管理系统（即办公系统人事档案）。人事档案数据库严格按管理权限进行提交和使用。人事档案数据库为公司商业机密，公司任何人员不得私自窃取、拷贝系统。</p>
                    <p>2、人力资源部（人事科）必须根据人事变动情况随时更新人事数据信息。人事档案数据库为公司管理的决策部门提供各种人事方面的基本数据，并为人事统计分析提供资料。人力资源部应认真做好人事档案数据库的收集、鉴别、整理、保管和利用，充分发挥人事档案数据信息的作用。</p>
                    <h4>第六条 处罚</h4>
                    <p>（一）人事档案保管人员必须严格遵守本管理办法，以高度的责任感，严肃、认真地处理好公司人事档案的管理。如工作中徇私或疏忽大意，导致保密资料外泄，则视其情节，按公司奖惩管理办法执行处罚。</p>
                    <p>（二）公司员工有义务向公司提供详尽真实的人个资料，并保证所提供的人事资料的真实性。如有提供虚假资料情况出现，属严重违纪行为，一经查实予以解除劳动合同，并不作任何补偿。员工因提供虚假资料对公司造成经济损失的，公司将保留追究其法律责任的权力。员工在职期间个人资料有变化的，应及时准确地向人力资源部（人事科）报告，以便使员工个人档案内有关记录得以相应更新，确保人事档案资料正确无误。</p>
                    <p>（三）人事数据库属于公司商业机密和员工个人私隐，公司任何人员不得利用任何手段非法或私自窃取、拷贝、偷阅，否则一经查实予以解除劳动合同，并不作任何补偿。</p>
                    <h4>第七条 附则</h4>
                    <p>（一）本管理细则自下发之月起执行。</p>
                    <p>（二）公司保留对本规定随时或定期作出修订的权利。最终解释权为公司人力资源部。</p>
                    <h2 name="0-2-4" className="point" id="0-2-4">五、实习生管理规范</h2>
                    <h3 name="0-2-4-0" className="point" id="0-2-4-0">1、实习生需求报备</h3>
                    <p>任用部/室负责人将实习生需求等基本信息报备至人力资源部，由人力资源部核定并与学院就业办对接。</p>
                    <h3 name="0-2-4-1" className="point" id="0-2-4-1">2、校企对接</h3>
                    <p>人力资源部负责与学院就业办及学生沟通并明确如下事项：</p>
                    <p>1、确认学生个人意愿，有长期在北京发展的决心且对重卡行业感兴趣者优先录用；</p>
                    <p>2、相关费用说明，明确个人承担部分，含交通费、体检费、相关物资费；</p>
                    <p>3、上岗前，通过公司培训考核者录用，未通过者不予录用。</p>
                    <h3 name="0-2-4-2" className="point" id="0-2-4-2">3、接站、食宿安排</h3>
                    <p>人力资源部协调后勤保障部负责实习生接站及食宿安排。</p>
                    <h3 name="0-2-4-3" className="point" id="0-2-4-3">4、实习生报到、领用物资</h3>
                    <p>实习生到位后需办理如下事宜：</p>
                    <p>1、到人力资源部报到并建档（地点：会所207办公室），需携带身份证、驾驶证（如有）、护照（如有）、入职体检报告、一寸彩色照片两张，<strong>校方实习协议（如有）</strong>
                    </p>
                    <p>2、领用物资，包括维修工服（仅针对维修岗）、劳保鞋、当季公司形象工服、被褥。相关费用明细工按照公司当季价格。</p>
                    <p>①公司为其配维修工服、劳保鞋、当季形象工服各一套，入职未满一年离职者，费用全部由个人承担，将在离职工资表中扣除，如离职工资不足以扣除以上费用，则需本人补交差额部分现金；入职满一年的员工，作为公司福利不予扣款。入职一年内员工自愿额外购买则全额自行承担；入职满一年的员工如自愿额外购买，作为公司福利公司将代其承担一半费用。</p>
                    <p>②公司为其配发被褥一套，入职未满一年离职的员工，费用全部由个人承担，入职满一年离职者，公司将承担一半费用即150元作为福利。此项费用将在离职工资表中扣除，如离职工资不足以扣除以上费用，则需本人补交差额部分现金。</p>
                    <p>③物资领用办法：实习生到人力资源部报到登记时直接配发；其他时间自愿额外购买者，按照公司统一规定，持财务收费凭据到后勤保障部/人力资源部专项负责人处领取（电话：80261668；办公地点：会所207办公室）。</p>
                    <h3 name="0-2-4-4" className="point" id="0-2-4-4">5、保险</h3>
                    <p>实习生报到后一星期内（培训实操阶段，并确定为有效上岗后），公司为其免费缴纳意外险一份。</p>
                    <h3 name="0-2-4-5" className="point" id="0-2-4-5">6、培训机制</h3>
                    <p>1、实习生报到建档后，在集团总部大兴基地接受为期15-20天的集中培训；</p>
                    <p>①人力资源部和云豪学院共同负责组织新员工培训，主要内容为《员工手册》。</p>
                    <p>②云豪学院负责组织岗位技能培训，包括：各基地工作环境实地参观体验、安全操作和技能培训，重型卡车整车构造和实际操作、业务流程等。</p>
                    <h3 name="0-2-4-6" className="point" id="0-2-4-6">7、分配</h3>
                    <p>集中培训结束后，由人力资源部结合业务部门需求及实习生综合情况进行统一分配。</p>
                    <h3 name="0-2-4-7" className="point" id="0-2-4-7">8、实习期考核</h3>
                    <p>关于实习期与试用期名词解释及实习生待遇问题，做出如下说明：</p>
                    <p>1、对实习期、试用期名词解</p>
                    <p>1.1 实习期：实习期只适用于在校学生。在校学生充分结合自己的理论知识，参加社会实践工作，以充分提高自身综合素质和工作适应能力的一段时期。实习期满即实习结束，方可转正；</p>
                    <p>1.2 试用期：试用期是指用人单位和劳动者双方相互了解、确定对方是否符合自己的招聘条件或求职条件而约定的考察期（即社会招聘）。</p>
                    <p>2、实习期实习生需与公司另行签订实习协议，待实习期满后，实习期满后可不经过试用期，可双方达成意向直接转正，签属劳动合同；</p>
                    <p>3、实习生在实习期实习薪资制定统一标准，实习补贴2000元/月，<strong>单休补贴200元，全勤（本月无休息）奖励200元。</strong>如实习期各方面表现优秀，三个月后可提出以补贴或奖励形式<strong>（500-1000元）</strong>作为鼓励和学习的榜样，填写申请表具体金额及发放方式由部门经理提出，管理中心或管理公司负责人审核，报备至人力资源部及财务部备案；如实习期间由于工作消极怠慢，工作态度差，或违反公司规章制度者，部门经理可提出结束实习，并报到人力资源部解除实习协议。
                    </p>
                    <p>4、实习生在实习期间同样遵守《员工手册》各项规章制度并进行考核。</p>
                    <h3 name="0-2-4-8" className="point" id="0-2-4-8">9、实习生日常管理</h3>
                    <p><strong>1、实习生在我公司实习期间，人力资源部接洽人员为其实习期的辅导员。</strong></p>
                    <p><strong>2、实习生在公司实习期间，为保护实习生的安全，原则上不外派参与抢修工作。</strong></p>
                    <p>
                        <strong>3、实习生不论何种原因需要外出的，必须向部门经理及其辅导员报备，说明外出理由，待部门经理和辅导员批准后方可外出，外出不予报备达3次的，将由公司直接与学校对接，以不服从管理，不符合实习标准为由退回学校。</strong>
                    </p>
                    <p>
                        <strong>4、未经部门经理及辅导员批准擅自外宿、申请外宿原因与实际情况不符或频繁申请外宿的，公司将取消其住宿资格。外宿期间造成的一切人身财产损失和伤亡事故，公司概不负责</strong>
                    </p>
                    <p>
                        <strong>5、实习期间需请假的，必须向其部门经理及其辅导员报备，未经报备擅自离岗的，由公司直接与学校对接，以不服从管理，不符合实习标准为由退回学校。</strong>
                    </p>
                    <p><strong>6、实习生未经批准，擅自外出或离岗的，若发生任何意外，公司均不予负责。</strong></p>
                    <p><strong>7、人力资源部接洽人员对于在司实习的学生每两月进行一次回访，了解其在司工作状态。</strong></p>
                    <p>注：1.实习期或试用期内的员工没有动态积分考核，只视情况享受固定积分，由相关部门负责人确定，特殊情况特殊处理。</p>
                    <p><strong>2. 各管理公司必须按照《员工考勤管理细则》安排实习生进行合理休息。</strong></p>
                    <h2 name="0-2-5" className="point" id="0-2-5">六、办公系统操作规范</h2>
                    <h3 name="0-2-5-0" className="point" id="0-2-5-0">一、适用范围(钉钉办公操作系统）</h3>
                    <p>本操作规范适用于云豪集团全体人员</p>
                    <h3 name="0-2-5-1" className="point" id="0-2-5-1">二、使用原则</h3>
                    <p>1. 所有员工必须申请注册“钉钉”账号，注册成功后此账号仅作为工作使用；</p>
                    <p>2. “钉钉”是非即时性沟通工具，重要紧急的工作沟通，仍需使用电话沟通；</p>
                    <p>3. 日常管理及工作申请尽量采用“钉钉”软件的审批功能，执行无纸化审批办公；</p>
                    <p>4. 重视“钉钉”软件管理平台的“考勤打卡”“日志”和“审批”功能，目的是了解员工的去向、工作内容和目标达成情况，及时发现并解决问题；同时简化内部日常工作的管理流程；</p>
                    <p>5. 根据公司管理需要，增加“钉钉”功能另行通知。</p>
                    <h3 name="0-2-5-2" className="point" id="0-2-5-2">三、各版块审批流程及细则</h3>
                    <h3 name="0-2-5-2-0" className="point" id="0-2-5-2-0">1. 人事板块</h3>
                    <img src={renshibankuai} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <img src={renshibankuai1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <img src={renshibankuai3} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <img src={renshibankuai2} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <h3 name="0-2-5-2-1" className="point" id="0-2-5-2-1">2.行政板块</h3>
                    <img src={xingzhengbankuai} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <h3 name="0-2-5-2-2" className="point" id="0-2-5-2-2">3.后勤保障板块</h3>
                    <img src={houqinbaozhangbankuai} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <h3 name="0-2-5-2-3" className="point" id="0-2-5-2-3">4.积分制审批（固定积分审批、动态积分审批）</h3>
                    <img src={jifenzhishenpi} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <h3 name="0-2-5-2-4" className="point" id="0-2-5-2-4">5.财务版块（薪资审批）</h3>
                    <img src={caiwubankuai} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/>   
                  
                    <h3 name="0-2-5-2-5" className="point"id="0-2-5-2-5">3.6 其它版块功能可自行使用</h3>
                    <p><strong>3.6.1 公告</strong></p>
                    <p><strong>3.6.2 日志包括：拜访记录、会议记录</strong></p>
                    <p><strong>3.6.3 找商机</strong></p>
                    <p><strong>3.6.4 扫名片</strong></p>
                    <p><strong>3.6.5 添加客户</strong></p>
                    <p><strong>3.6.6 电话会议</strong></p>
                    <p><strong>3.6.7 办公电话</strong></p>
                    <p><strong>3.6.8 视频会议</strong></p>
                    <p><strong>3.6.9 钉邮</strong></p>
                    <p><strong>3.6.10 智能报表</strong></p>
                    <p><strong>3.6.11 钉盘</strong></p>
                    <p><strong>3.6.12 智能会务</strong></p>

                    <h3 name="0-2-5-3" className="point"
                        id="0-2-5-3">4、远程办公管理制度（试用行）</h3>
                    <h4>第一条 目的</h4>
                    <p>为了切实响应国家号召，保证员工的安全防护与身体健康，同时为合理、灵活、高效的安排工作，对远程办公行为进行有效管理，特制定本管理制度。</p>

                    <h4>第二条 适用范围</h4>
                    <p>本制度适用云豪集团各部门所有员工。</p>

                    <h4>第三条 考勤管理</h4>
                    <p>3.1 远程办公期间采取与公司考勤制度同步的作息时间，</p>
                    <p>3.2 远程办公期间打卡形式改为钉钉-在家打卡即“外勤打卡”，正常工作时间未打卡视为缺勤处理；</p>
                    <p>3.3 远程办公期间员工假期审批可在钉钉系统完成，因员工不幸感肺炎或其他疾病无法最有效开展工作的情况，</p>
                    <p>公司统一按照病假处理或接受国家有关部门规定的处理方式；</p>
                    <p>3.4 管理者及员工未按规定完成本制度中的第五条第一项的工作部署/工作日报，第七条第一项的工作成果确认，视为当日缺勤处理。</p>

                    <h4>第四条 工作纪律</h4>
                    <p>4.1 远程办公视为正常上班出勤，全员保持钉钉在线，一小时内未回复工作消息及未按时参加远程会议，公司有权按照当日缺勤处理；累计超过3次按一次旷工处理；</p>
                    <p>4.2 员工应保持办公场所所具备的网络与通话条件，并及时接通办公电话，回复信息，响应上级工作指示；</p>
                    <p>4.3 远程办公应遵守诚信、自律、高效的原则，确保保质保量完成工作任务；</p>
                    <p>4.4 员工应准时参加公司语音会议、视频会议，若需要接入视频则需注意衣着整洁，形象端庄大方。</p>
                    <p>4.5 员工不得无故不响应工作任务。</p>
                    <br/>
                    <h4>第五条 任务管理</h4>
                    <p>5.1 远程办公期间公司可采用“项目群”进行项目管理，部门管理者需明确、清晰、高效的部署当日工作标准与要求，用钉钉项目群安全沟通，创建和分配工作任务，追踪完成情况，事事有着落，件件有回应。员工并按要求完成当日工作并及时填写工作日报；</p>
                    <p>5.2 远程办公期间公司的远程会议提前1个小时由钉钉群及钉钉远程会议系统通知。</p>
                    <br/>
                    <h4>第六条 审批管理</h4>
                    <p>6.1 远程办公期间员工请假、工作资源需求均通过钉钉线上系统实现，暂停一切外出及出差申请；</p>
                    <p>6.2 远程办公期间财务报销、费用申请等以财务部规定为准</p>
                    <p>6.3 远程办公期间人力资源部所有人事手续流程及招聘工作都选择钉钉方式进行，办理招聘入职手续先通过钉钉提交录用审批通过之后，待正常办公后再办理入职手续；办理离职手续通过钉钉提交辞职报告，远程确认方式完成结算，并通过电签方式确定离职证明或快递方式邮寄离职证明。</p>
                    <br/>
                    <h4>第七条 成果确认</h4>
                    <p>7.1 员工远程办公，应根据规定进行考勤打卡及当日工作日报填写，由部门负责人审批同意后既完成远程办公成果的确认；</p>
                    <p>7.2 各部门负责人牵头指定统计做为考勤负责人，当日汇总远程办公考勤与成果确认情况并与人力资源部门对接考勤与工作成果。</p>
                    <br/>
                    <h4>第八条 工作安全</h4>
                    <p>8.1 远程办公期间特此注意环境保护与自身安全，避免接触人流密集场所，应取消聚会活动，无特殊事宜不出门；</p>
                    <p>8.2 远程办公期间若有家人生病，疑似疫情或疫情感染症状，可凭医院开具的治疗证明申请假期；</p>
                    <p>8.3 员工未在安全工作环境中工作或处理非工作事宜造成人身财产损失的，自行承担相应的风险与责任。</p>
                    <br/>
                    <h4>第九条 解除期限</h4>
                    <p>本制度限于2020年疫情期间的特殊办公管理办法，恢复办公时间后另行通知！ </p>
                    <p>附件：《员工在家办公钉钉指南》即《阿里巴巴钉钉在家办公指南》</p>
                
                    <h2 name="0-2-6" className="point" id="0-2-6">七、九级能力范畴</h2>
                    <img src={gongzhongdagang1} alt="" style={{width  : '700px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>1、管理人员</h4>
                    <br/>
                    <img src={guanlirenyuan1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>二、整车销售</h4>
                    <br/>
                    <img src={zhengchexiaoshou1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>三、配件销售</h4>
                    <br/>
                    <img src={peijianxiaoshou1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>四、服务销售（走出去）</h4>
                    <br/>
                    <img src={fuwuxiaoshou1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>五、客户链接（线上/线下来访）</h4>
                    <br/>
                    <img src={kehuxinxi1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>六、索赔报单员</h4>
                    <br/>
                    <img src={suopeibaodan1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>七、维修技师</h4>
                    <br/>
                    <img src={weixiujigong1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>八、见习生</h4>
                    <br/>
                    <img src={xuetugong1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>九、采购计划员</h4>
                    <br/>
                    <img src={caigoujihua1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十、物流配送员</h4>
                    <br/>
                    <img src={wuliupeisong1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十一、仓储管理员</h4>
                    <br/>
                    <img src={kufangguanli1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十二、行政人事</h4>
                    <br/>
                    <img src={renshizhuanyuan1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十三、财务人员</h4>
                    <br/>
                    <img src={caiwujizhang1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十四、统计人员</h4>
                    <br/>
                    <img src={tongjirenyuan1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十五、IT人员</h4>
                    <br/>
                    <img src={IT1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十六、国际贸易人员</h4>
                    <br/>
                    <img src={guojimaoyi1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <br/>
                    <h4>十七、法务人员</h4>
                    <br/>
                    <img src={fawuzhuanyuan1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <h4>十八、车间产业工人</h4>
                    <br/>
                    <img src={chejianchanyegongren} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 

                    <h4>十九、技术工艺开发人员</h4>
                    <br/>
                    <img src={jishugongyikaifarenyuan} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                    <h4>二十、质检、设备人员</h4>
                    <br/>
                    <img src={zhijianshebeirenyuan} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 

                    <br/>
                </div>
            </div>
        )
    }
}

export default Section$;